import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import Amplify from '@aws-amplify/core';
import gql from 'graphql-tag';
import { Subject, Observable } from 'rxjs';
import { __awaiter, __generator, __makeTemplateObject } from 'tslib';
import Auth from '@aws-amplify/auth';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { OAuthService, AuthConfig, OAuthModule } from 'angular-oauth2-oidc';
import { Apollo, ApolloModule } from 'apollo-angular';
import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, AlertModule } from 'ngx-alerts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { Injectable, InjectionToken, Inject, NgZone, NgModule, Component, Input, ViewChild, HostListener, defineInjectable, inject } from '@angular/core';
import { HttpClient, HttpClientModule, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/message.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MessageService = /** @class */ (function () {
    function MessageService() {
    }
    /**
     * @param {?} keyName
     * @param {?} keyValue
     * @return {?}
     */
    MessageService.prototype.setEnv = /**
     * @param {?} keyName
     * @param {?} keyValue
     * @return {?}
     */
    function (keyName, keyValue) {
        /** @type {?} */
        var newKeyVal = {};
        if (keyName && keyValue && keyValue && Object.keys(keyValue).length > 0) {
            /** @type {?} */
            var currEnv = this.getEnv();
            if (currEnv === null) {
                sessionStorage.setItem(keyName, btoa(JSON.stringify(keyValue)));
            }
            else {
                newKeyVal = keyValue;
                for (var key in currEnv) {
                    if (newKeyVal[key] === undefined) {
                        newKeyVal[key] = currEnv[key];
                    }
                }
                sessionStorage.setItem(keyName, btoa(JSON.stringify(newKeyVal)));
            }
        }
    };
    /**
     * @param {?=} keyName
     * @return {?}
     */
    MessageService.prototype.getEnv = /**
     * @param {?=} keyName
     * @return {?}
     */
    function (keyName) {
        if (keyName === void 0) { keyName = 'environmentData'; }
        /** @type {?} */
        var keyValue = sessionStorage.getItem(keyName);
        if (keyValue && typeof keyValue === 'string') {
            return JSON.parse(atob(keyValue));
        }
        return null;
    };
    /**
     * @return {?}
     */
    MessageService.prototype.getClaimObj = /**
     * @return {?}
     */
    function () {
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            /** @type {?} */
            var claimObj = localStorage.getItem('claimObj');
            if (claimObj && typeof claimObj === 'string') {
                resolve(JSON.parse(claimObj));
                return true;
            }
            resolve(null);
        }));
    };
    MessageService.decorators = [
        { type: Injectable }
    ];
    return MessageService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/neo-appsdk-login.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LoginUser = /** @class */ (function () {
    function LoginUser(email, password) {
        this.email = email;
        this.password = password;
        this.email = '';
        this.password = '';
    }
    return LoginUser;
}());
var NeoConfigModel = /** @class */ (function () {
    function NeoConfigModel(graphql_url, application_id, config_fetch_env, cloud_provider, project, after_login_land_url, useHash, skipRoutes, isCustomHost) {
        this.graphql_url = graphql_url;
        this.application_id = application_id;
        this.config_fetch_env = config_fetch_env;
        this.cloud_provider = cloud_provider;
        this.project = project;
        this.after_login_land_url = after_login_land_url;
        this.useHash = useHash;
        this.skipRoutes = skipRoutes;
        this.isCustomHost = isCustomHost;
        this.isCustomHost = false;
        this.after_login_land_url = '/';
        this.useHash = false;
        this.skipRoutes = [];
        this.cloud_provider = undefined;
    }
    return NeoConfigModel;
}());
/** @enum {string} */
var LoginType = {
    COGNITO: "COGNITO",
    OKTA: "OKTA",
    AZURE: "AZURE",
    B2C: "B2C",
    FIREBASE: "FIREBASE",
};

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/neo-config.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var NeoConfigService = new InjectionToken('NeoConfigModel');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/privacy-policy/privacy-policy.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PrivacyPolicyService = /** @class */ (function () {
    function PrivacyPolicyService(apollo) {
        this.apollo = apollo;
        this.isOpened = new Subject();
    }
    /**
     * @param {?=} initialRoute
     * @param {?=} dynamicRoute
     * @param {?=} claimData
     * @return {?}
     */
    PrivacyPolicyService.prototype.openModal = /**
     * @param {?=} initialRoute
     * @param {?=} dynamicRoute
     * @param {?=} claimData
     * @return {?}
     */
    function (initialRoute, dynamicRoute, claimData) {
        this.initialParam = initialRoute;
        this.dynamicRoute = dynamicRoute;
        this.claimData = claimData;
        this.isOpened.next({
            status: true,
            dynamicRoute: dynamicRoute,
            initialRoute: initialRoute,
            claimData: claimData,
        });
        this.isOpened.complete();
    };
    /**
     * @return {?}
     */
    PrivacyPolicyService.prototype.modalStatus = /**
     * @return {?}
     */
    function () {
        return this.isOpened.asObservable();
    };
    /**
     * @param {?} emailId
     * @return {?}
     */
    PrivacyPolicyService.prototype.updatePrivacyPolicyAcceptance = /**
     * @param {?} emailId
     * @return {?}
     */
    function (emailId) {
        /** @type {?} */
        var query = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["mutation updateUser ($hasAccepted: Boolean!, $userEmailId: String!, $acceptedDate: Datetime) {\n            updateUserByEmail(input: {\n                patch: {acceptedPrivacyPolicy: $hasAccepted, privacyPolicyDate: $acceptedDate}, email: $userEmailId}) {\n                user {\n                    email\n                    acceptedPrivacyPolicy\n                }\n            }\n        }"], ["mutation updateUser ($hasAccepted: Boolean!, $userEmailId: String!, $acceptedDate: Datetime) {\n            updateUserByEmail(input: {\n                patch: {acceptedPrivacyPolicy: $hasAccepted, privacyPolicyDate: $acceptedDate}, email: $userEmailId}) {\n                user {\n                    email\n                    acceptedPrivacyPolicy\n                }\n            }\n        }"])));
        return this.apollo.mutate({
            mutation: query,
            variables: {
                hasAccepted: true,
                userEmailId: emailId,
                acceptedDate: new Date()
            }
        }).pipe(map((/**
         * @param {?} res
         * @return {?}
         */
        function (res) { return res.data; })));
    };
    /**
     * @return {?}
     */
    PrivacyPolicyService.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.isOpened.next({
            status: false,
            dynamicRoute: this.dynamicRoute,
            initialRoute: this.initialParam,
            claimData: this.claimData
        });
        this.isOpened.complete();
    };
    PrivacyPolicyService.decorators = [
        { type: Inject, args: [{
                    provideIn: 'root'
                },] }
    ];
    /** @nocollapse */
    PrivacyPolicyService.ctorParameters = function () { return [
        { type: Apollo }
    ]; };
    return PrivacyPolicyService;
}());
var templateObject_1;

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/neo-util.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// import { initializeApp } from 'firebase/app';
// import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
var NeoUtilService = /** @class */ (function () {
    function NeoUtilService(http, configService, msgService, oAuthService, alertService, ngZone, privacyService) {
        this.http = http;
        this.configService = configService;
        this.msgService = msgService;
        this.oAuthService = oAuthService;
        this.alertService = alertService;
        this.ngZone = ngZone;
        this.privacyService = privacyService;
        this.localStorageKeys = ['claimObj', 'user_menu_items', 'docUrls', 'access_token', 'id_token', 'scope', 'state', 'expires_at', 'loginType', 'menu_items'];
        this.loginType = (/**
         * @return {?}
         */
        function () {
            /** @type {?} */
            var loginType = localStorage.getItem('loginType');
            if (loginType) {
                return LoginType[loginType];
            }
            return LoginType.COGNITO;
        });
    }
    /**
     * @param {?=} graphQlUrl
     * @return {?}
     */
    NeoUtilService.prototype.fetchMenu = /**
     * @param {?=} graphQlUrl
     * @return {?}
     */
    function (graphQlUrl) {
        if (graphQlUrl === void 0) { graphQlUrl = null; }
        /** @type {?} */
        var menuItems = localStorage.getItem('menu_items');
        if (menuItems && typeof menuItems === 'string') {
            return new Observable((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                data.next(JSON.parse(menuItems));
                data.complete();
            }));
        }
        else {
            /** @type {?} */
            var menuUrl = '';
            if (!graphQlUrl) {
                this.envData = this.msgService.getEnv('environmentData');
                menuUrl = this.envData.graphql_url + "apps/" + this.configService.application_id + "/menus";
            }
            if (graphQlUrl && graphQlUrl.length > 0) {
                menuUrl = graphQlUrl + "apps/" + this.configService.application_id + "/menus";
            }
            return this.http.get(menuUrl).pipe(map((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                localStorage.setItem('menu_items', JSON.stringify(data));
                return data;
            })));
        }
    };
    /**
     * @param {?} graphQlurl
     * @return {?}
     */
    NeoUtilService.prototype.getClaim = /**
     * @param {?} graphQlurl
     * @return {?}
     */
    function (graphQlurl) {
        /** @type {?} */
        var claimUrl = graphQlurl + "apps/" + this.configService.application_id + "/claims?configname=" + this.configService.config_fetch_env;
        return this.http.get(claimUrl).pipe(map((/**
         * @param {?} data
         * @return {?}
         */
        function (data) { return data; })));
    };
    /**
     * @param {?} configData
     * @return {?}
     */
    NeoUtilService.prototype.setOktaConfig = /**
     * @param {?} configData
     * @return {?}
     */
    function (configData) {
        if (!configData.oktaDomain || !configData.oktaClientId) {
            return false;
        }
        /** @type {?} */
        var authData = new AuthConfig();
        authData.issuer = configData.oktaDomain;
        authData.clientId = configData.oktaClientId;
        authData.redirectUri = window.location.origin + "/login";
        authData.scope = 'openid profile email offline_access';
        this.oAuthService.configure(authData);
        this.oAuthService.tokenValidationHandler = new JwksValidationHandler();
        this.oAuthService.loadDiscoveryDocumentAndTryLogin();
        this.oAuthService.setStorage(localStorage);
        this.oAuthService.oidc = true;
    };
    /**
     * @param {?} configData
     * @return {?}
     */
    NeoUtilService.prototype.setAzureConfig = /**
     * @param {?} configData
     * @return {?}
     */
    function (configData) {
        if (!configData.ad_issuer || !configData.ad_client_id) {
            return false;
        }
        /** @type {?} */
        var authData = new AuthConfig();
        authData.issuer = configData.ad_issuer;
        authData.clientId = configData.ad_client_id;
        authData.scope = 'openid profile email offline_access';
        authData.redirectUri = window.location.origin + "/login";
        authData.responseType = 'id_token token';
        authData.oidc = true;
        this.oAuthService.configure(authData);
        this.oAuthService.strictDiscoveryDocumentValidation = false;
        this.oAuthService.loadDiscoveryDocumentAndTryLogin();
        this.oAuthService.setStorage(localStorage);
    };
    /**
     * @param {?} configData
     * @return {?}
     */
    NeoUtilService.prototype.setCognitoConfig = /**
     * @param {?} configData
     * @return {?}
     */
    function (configData) {
        if (!configData.pool_id || !configData.client_id) {
            return false;
        }
        Amplify.configure({
            Auth: {
                region: configData.region,
                userPoolId: configData.pool_id,
                userPoolWebClientId: configData.client_id,
            },
        });
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.azureB2CLogin = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var configData = this.msgService.getEnv('environmentData');
        var b2cConfig = configData.b2cConfig;
        if (b2cConfig) {
            /** @type {?} */
            var authData = new AuthConfig();
            authData.issuer = "" + b2cConfig.issuer;
            authData.clientId = b2cConfig.clientId;
            authData.showDebugInformation = true;
            authData.redirectUri = window.location.origin + "/login";
            authData.responseType = 'token id_token';
            authData.strictDiscoveryDocumentValidation = false;
            authData.oidc = false;
            authData.scope = "openid profile offline_access " + b2cConfig.clientId;
            this.oAuthService.tokenValidationHandler = new JwksValidationHandler();
            this.oAuthService.configure(authData);
            this.oAuthService.loadDiscoveryDocument(b2cConfig.authWellknownEndpointUrl).then((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                _this.oAuthService.tryLogin({}).then((/**
                 * @param {?} data
                 * @return {?}
                 */
                function (data) {
                    _this.oAuthService.initLoginFlow('/welcome');
                })).catch((/**
                 * @param {?} err
                 * @return {?}
                 */
                function (err) {
                    console.log(err);
                }));
            }));
        }
        else {
            console.error('Invalid B2C configuration');
        }
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.checkFragmentUrl = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var fragmentUrl = window.location.hash.substr(1);
        if (fragmentUrl.length > 0) {
            /** @type {?} */
            var pos = fragmentUrl.search('id_token=');
            if (pos > 0) {
                return true;
            }
            else {
                return false;
            }
        }
    };
    /**
     * @param {?} email
     * @param {?} password
     * @param {?=} initialRouteparam
     * @param {?=} dynamicRouteFn
     * @return {?}
     */
    NeoUtilService.prototype.cognitoSignIn = /**
     * @param {?} email
     * @param {?} password
     * @param {?=} initialRouteparam
     * @param {?=} dynamicRouteFn
     * @return {?}
     */
    function (email, password, initialRouteparam, dynamicRouteFn) {
        var _this = this;
        if (initialRouteparam === void 0) { initialRouteparam = '/'; }
        this.envData = this.msgService.getEnv('environmentData');
        if (!this.envData) {
            window.location.assign('login');
        }
        this.setCognitoConfig(this.envData);
        Auth.signIn(email, password).then((/**
         * @param {?} success
         * @return {?}
         */
        function (success) {
            localStorage.setItem('access_token', success.signInUserSession.idToken.jwtToken);
            localStorage.setItem('expires_at', (success.signInUserSession.idToken.payload.exp * 1000).toString());
            if (_this.envData) {
                _this.fetchClaim(initialRouteparam, dynamicRouteFn);
            }
        })).catch((/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.alertService.danger(err.message);
        }));
    };
    /**
     * @param {?=} initialRoute
     * @return {?}
     */
    NeoUtilService.prototype.ssoLogin = /**
     * @param {?=} initialRoute
     * @return {?}
     */
    function (initialRoute) {
        if (initialRoute === void 0) { initialRoute = '/'; }
        this.envData = this.msgService.getEnv('environmentData');
        if (!this.envData) {
            window.location.assign('login');
        }
        localStorage.setItem('loginType', LoginType.OKTA);
        this.setOktaConfig(this.envData);
        this.oAuthService.initLoginFlow(initialRoute);
    };
    /**
     * @param {?=} initialRoute
     * @return {?}
     */
    NeoUtilService.prototype.azureLogin = /**
     * @param {?=} initialRoute
     * @return {?}
     */
    function (initialRoute) {
        if (initialRoute === void 0) { initialRoute = '/'; }
        this.envData = this.msgService.getEnv('environmentData');
        if (!this.envData) {
            window.location.assign('login');
        }
        localStorage.setItem('loginType', LoginType.AZURE);
        this.setAzureConfig(this.envData);
        this.oAuthService.initLoginFlow(initialRoute);
    };
    /**
     * @param {?=} dynamicRouteFn
     * @return {?}
     */
    NeoUtilService.prototype.ssoReturn = /**
     * @param {?=} dynamicRouteFn
     * @return {?}
     */
    function (dynamicRouteFn) {
        var _this = this;
        this.oAuthService.events.subscribe((/**
         * @param {?} __0
         * @return {?}
         */
        function (_a) {
            var type = _a.type;
            switch (type) {
                case 'token_received':
                    {
                        _this.envData = _this.msgService.getEnv('environmentData');
                        if (_this.envData) {
                            _this.fetchClaim('', dynamicRouteFn);
                        }
                    }
                    break;
                case 'token_error': {
                    _this.alertService.danger('Invalid Credential');
                    _this.ngZone.runOutsideAngular((/**
                     * @return {?}
                     */
                    function () {
                        setTimeout((/**
                         * @return {?}
                         */
                        function () {
                            window.location.href = _this.oAuthService.state;
                        }), 2000);
                    }));
                }
            }
        }));
    };
    /**
     * @param {?=} initialRouteParam
     * @param {?=} dynamicRouteFn
     * @return {?}
     */
    NeoUtilService.prototype.fetchClaim = /**
     * @param {?=} initialRouteParam
     * @param {?=} dynamicRouteFn
     * @return {?}
     */
    function (initialRouteParam, dynamicRouteFn) {
        var _this = this;
        /** @type {?} */
        var hassAccepted = false;
        this.getClaim(this.envData.graphql_url).subscribe((/**
         * @param {?} claimData
         * @return {?}
         */
        function (claimData) {
            if (Object.keys(claimData).length > 0) {
                localStorage.setItem('claimObj', JSON.stringify(claimData));
                if (!claimData || !claimData.roles || claimData.roles.length === 0) {
                    _this.clearLocalStorage();
                    _this.alertService.danger("You don't have a valid role assigned to this application. Please contact your administrator");
                    setTimeout((/**
                     * @return {?}
                     */
                    function () { window.location.href = '/login'; }), 5000);
                }
                else {
                    // if enablePP == false manually setting has hasAcceptedPrivacyPolicy as true
                    if (!_this.isPrivacyPolicyEnabled || (claimData.userInfo.hasAcceptedPrivacyPolicy == undefined)) {
                        claimData.userInfo.hasAcceptedPrivacyPolicy = true;
                        localStorage.setItem('claimObj', JSON.stringify(claimData));
                    }
                    if (claimData.userInfo.hasAcceptedPrivacyPolicy !== undefined) {
                        hassAccepted = claimData.userInfo.hasAcceptedPrivacyPolicy;
                    }
                    _this.msgService.setEnv('environmentData', claimData.configuration);
                    if (!hassAccepted) {
                        _this.privacyService.openModal(initialRouteParam, dynamicRouteFn, claimData);
                        return true;
                    }
                    else {
                        _this.getMenuFn(initialRouteParam, dynamicRouteFn, claimData);
                    }
                }
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log(err);
            _this.errorMsg(err);
        }));
    };
    /**
     * @param {?} initialRouteParam
     * @param {?} dynamicRouteFn
     * @param {?} claimData
     * @return {?}
     */
    NeoUtilService.prototype.getMenuFn = /**
     * @param {?} initialRouteParam
     * @param {?} dynamicRouteFn
     * @param {?} claimData
     * @return {?}
     */
    function (initialRouteParam, dynamicRouteFn, claimData) {
        var _this = this;
        this.fetchMenu().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.storeMenuData(data);
            if (sessionStorage.getItem('initialRoute')) {
                /** @type {?} */
                var initialRoutes = sessionStorage.getItem('initialRoute');
                sessionStorage.removeItem('initialRoute');
                window.location.href = initialRoutes;
            }
            else if (dynamicRouteFn && typeof dynamicRouteFn === 'function') {
                window.location.href = dynamicRouteFn(claimData);
            }
            else {
                /** @type {?} */
                var iscognito = _this.isCognito();
                if (!iscognito && _this.oAuthService.state) {
                    window.location.href = _this.oAuthService.state;
                }
                if (initialRouteParam) {
                    window.location.href = initialRouteParam;
                }
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.errorMsg(err);
        }));
    };
    /**
     * @param {?} err
     * @return {?}
     */
    NeoUtilService.prototype.errorMsg = /**
     * @param {?} err
     * @return {?}
     */
    function (err) {
        this.clearLocalStorage();
        if (err && err.error && err.error.message === 'License Expired. Please contact Administrator.') {
            this.alertService.danger('Your NEO License has expired. Please contact the System Administrator.');
        }
        else {
            this.alertService.danger('Cannot fetch your role and permissions. Please contact your administrator');
        }
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.isValidAccessToken = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var token = this.getAccessToken();
        if (token != null) {
            /** @type {?} */
            var decodedt = this.parseJwt(token);
            if (decodedt.exp > Math.floor(Date.now() / 1000)) {
                return true;
            }
        }
        return false;
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.hasAccessToken = /**
     * @return {?}
     */
    function () {
        if (this.getAccessToken() != null) {
            return true;
        }
        return false;
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.getAccessToken = /**
     * @return {?}
     */
    function () {
        return localStorage.getItem('access_token');
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.getAccessTokenExpirationTime = /**
     * @return {?}
     */
    function () {
        return parseInt(localStorage.getItem('expires_at'), 10);
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.getIdToken = /**
     * @return {?}
     */
    function () {
        return localStorage.getItem('id_token');
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.getUserClaim = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var claimObj = localStorage.getItem('claimObj');
        if (claimObj && typeof claimObj === 'string') {
            return JSON.parse(claimObj);
        }
        return null;
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.getUserName = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var claimData = this.getUserClaim();
        if (claimData) {
            return claimData.userInfo.firstName + ' ' + claimData.userInfo.lastName;
        }
        return '';
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.getHasUserAcceptedPrivacyPolicy = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var claimData = this.getUserClaim();
        if (claimData && (claimData.userInfo.hasAcceptedPrivacyPolicy !== undefined)) {
            return claimData.userInfo.hasAcceptedPrivacyPolicy;
        }
        return false;
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.getUserEmail = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var claimData = this.getUserClaim();
        if (claimData) {
            return claimData.userInfo.email;
        }
        return '';
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.getUserRole = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var claimData = this.getUserClaim();
        if (claimData) {
            return claimData.roles[0];
        }
        return '';
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.isCognito = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var isCognito = this.loginType();
        if (isCognito === LoginType.COGNITO) {
            return true;
        }
        return false;
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.signOut = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.isCognito()) {
            this.envData = this.msgService.getEnv('environmentData');
            this.setCognitoConfig(this.envData);
            Auth.signOut()
                .then((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                _this.clearLocalStorage();
            }))
                .catch((/**
             * @param {?} err
             * @return {?}
             */
            function (err) { return console.log(err); }));
        }
        else {
            this.clearLocalStorage();
            this.oAuthService.logOut();
        }
        window.location.href = '/login';
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.openChangePassword = /**
     * @return {?}
     */
    function () {
        this.envData = this.msgService.getEnv('environmentData');
        /** @type {?} */
        var changePasswordUrl = this.envData.neo_idm_url + '/change-password?email=' + this.getUserEmail() +
            '&redirectUrl=' + document.location.href;
        window.open(changePasswordUrl);
    };
    /**
     * @return {?}
     */
    NeoUtilService.prototype.clearLocalStorage = /**
     * @return {?}
     */
    function () {
        this.localStorageKeys.forEach((/**
         * @param {?} key
         * @return {?}
         */
        function (key) {
            localStorage.removeItem(key);
        }));
    };
    /**
     * @param {?} data
     * @return {?}
     */
    NeoUtilService.prototype.storeMenuData = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        if (data && data.length > 0) {
            /** @type {?} */
            var menuObj_1 = {};
            data.forEach((/**
             * @param {?} nav
             * @return {?}
             */
            function (nav) {
                if (nav.url_path !== '/') {
                    menuObj_1[nav.url_path] = nav.url_path;
                }
            }));
            localStorage.setItem('user_menu_items', JSON.stringify(menuObj_1));
        }
    };
    /**
     * @param {?=} intialRoute
     * @param {?=} dynamicRouteFn
     * @return {?}
     */
    NeoUtilService.prototype.b2cLoginReturn = /**
     * @param {?=} intialRoute
     * @param {?=} dynamicRouteFn
     * @return {?}
     */
    function (intialRoute, dynamicRouteFn) {
        this.envData = this.msgService.getEnv('environmentData');
        if (this.envData) {
            this.fetchClaim(intialRoute, dynamicRouteFn);
        }
    };
    /**
     * @param {?} token
     * @return {?}
     */
    NeoUtilService.prototype.parseJwt = /**
     * @param {?} token
     * @return {?}
     */
    function (token) {
        /** @type {?} */
        var base64Url = token.split('.')[1];
        /** @type {?} */
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        /** @type {?} */
        var jsonPayload = decodeURIComponent(atob(base64).split('').map((/**
         * @param {?} c
         * @return {?}
         */
        function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })).join(''));
        return JSON.parse(jsonPayload);
    };
    NeoUtilService.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */
    NeoUtilService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: NeoConfigModel, decorators: [{ type: Inject, args: [NeoConfigService,] }] },
        { type: MessageService },
        { type: OAuthService },
        { type: AlertService },
        { type: NgZone },
        { type: PrivacyPolicyService }
    ]; };
    /** @nocollapse */ NeoUtilService.ngInjectableDef = defineInjectable({ factory: function NeoUtilService_Factory() { return new NeoUtilService(inject(HttpClient), inject(NeoConfigService), inject(MessageService), inject(OAuthService), inject(AlertService), inject(NgZone), inject(PrivacyPolicyService)); }, token: NeoUtilService, providedIn: "root" });
    return NeoUtilService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/user-identity.guard.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AuthGuard = /** @class */ (function () {
    function AuthGuard(router, messageService, neoUtilService, privacypolicyService) {
        this.router = router;
        this.messageService = messageService;
        this.neoUtilService = neoUtilService;
        this.privacypolicyService = privacypolicyService;
        this.menuUrl = '';
        this.environment = this.messageService.getEnv('environmentData');
    }
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    AuthGuard.prototype.canActivate = /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    function (route, state) {
        return this.isAuthenticated(route, state);
    };
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    AuthGuard.prototype.canActivateChild = /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    function (route, state) {
        return this.isAuthenticated(route, state);
    };
    /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    AuthGuard.prototype.isAuthenticated = /**
     * @param {?} route
     * @param {?} state
     * @return {?}
     */
    function (route, state) {
        /** @type {?} */
        var hasAcceptedPrivacyPolicy = this.neoUtilService.getHasUserAcceptedPrivacyPolicy();
        if (!hasAcceptedPrivacyPolicy) {
            this.neoUtilService.signOut();
        }
        if (this.neoUtilService.isValidAccessToken()) {
            return this.checkPermission(state);
        }
        else {
            this.neoUtilService.signOut();
        }
    };
    /**
     * @param {?} state
     * @return {?}
     */
    AuthGuard.prototype.checkPermission = /**
     * @param {?} state
     * @return {?}
     */
    function (state) {
        /** @type {?} */
        var dirtyUrl = state.url;
        /** @type {?} */
        var cleanUrl;
        if (dirtyUrl.indexOf(';') > -1) {
            cleanUrl = dirtyUrl.split(';')[0];
        }
        else if (dirtyUrl.indexOf('?') > -1) {
            cleanUrl = dirtyUrl.split('?')[0];
        }
        else {
            cleanUrl = dirtyUrl;
        }
        /** @type {?} */
        var checkUrl = cleanUrl.split('/');
        /** @type {?} */
        var userMenu = localStorage.getItem('user_menu_items');
        if (state.url === '/welcome' || state.url === '/') {
            return true;
        }
        else if (userMenu && typeof userMenu === 'string') {
            /** @type {?} */
            var userMenus = JSON.parse(userMenu);
            return this.validateMenu(checkUrl, userMenus);
        }
        else {
            return false;
        }
    };
    /**
     * @param {?} checkUrl
     * @param {?} userMenus
     * @return {?}
     */
    AuthGuard.prototype.validateMenu = /**
     * @param {?} checkUrl
     * @param {?} userMenus
     * @return {?}
     */
    function (checkUrl, userMenus) {
        /** @type {?} */
        var firstLabelUrl = '';
        /** @type {?} */
        var secLablelUrl = '';
        if (checkUrl && checkUrl.length > 1) {
            firstLabelUrl = "/" + checkUrl[1];
        }
        if (checkUrl && checkUrl.length > 2) {
            secLablelUrl = "/" + checkUrl[1] + "/" + checkUrl[2];
        }
        if (userMenus[firstLabelUrl] || userMenus[secLablelUrl]) {
            return true;
        }
        else {
            this.router.navigate(['/page-not-found']);
            return false;
        }
    };
    AuthGuard.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AuthGuard.ctorParameters = function () { return [
        { type: Router },
        { type: MessageService },
        { type: NeoUtilService },
        { type: PrivacyPolicyService }
    ]; };
    return AuthGuard;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/token-interceptor.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TokenInterceptor = /** @class */ (function () {
    function TokenInterceptor(configService, neoUtilService) {
        this.configService = configService;
        this.neoUtilService = neoUtilService;
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    TokenInterceptor.prototype.intercept = /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    function (request, next) {
        if (this.neoUtilService.isValidAccessToken()) {
            if (request.url.indexOf('graphql.') !== -1 || request.url.indexOf('graphql-dataplatform.') !== -1
                || request.url.indexOf('localhost') !== -1) {
                request = request.clone({
                    headers: this.addGraphQLExtraHeaders(request.headers)
                });
            }
            else if (request.url.includes('X-Amz-Security-Token')) {
                request = request.clone({});
            }
            else {
                request = request.clone({
                    headers: this.addExtraHeaders(request.headers)
                });
            }
        }
        else if (this.neoUtilService.hasAccessToken()) {
            console.log('Token has expired. I am logging out');
            this.neoUtilService.signOut();
        }
        return next.handle(request);
    };
    /**
     * @private
     * @param {?} headers
     * @return {?}
     */
    TokenInterceptor.prototype.addExtraHeaders = /**
     * @private
     * @param {?} headers
     * @return {?}
     */
    function (headers) {
        headers = headers.append('Authorization', 'Bearer ' + this.neoUtilService.getAccessToken());
        return headers;
    };
    /**
     * @private
     * @param {?} headers
     * @return {?}
     */
    TokenInterceptor.prototype.addGraphQLExtraHeaders = /**
     * @private
     * @param {?} headers
     * @return {?}
     */
    function (headers) {
        headers = headers.append('Authorization', 'Bearer ' + this.neoUtilService.getAccessToken());
        headers = headers.append('appId', this.configService.application_id);
        headers = headers.append('Cache-Control', 'no-cache');
        headers = headers.append('Pragma', 'no-cache');
        headers = headers.append('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
        headers = headers.append('If-Modified-Since', '0');
        return headers;
    };
    TokenInterceptor.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TokenInterceptor.ctorParameters = function () { return [
        { type: NeoConfigModel, decorators: [{ type: Inject, args: [NeoConfigService,] }] },
        { type: NeoUtilService, decorators: [{ type: Inject, args: [NeoUtilService,] }] }
    ]; };
    return TokenInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/init-config.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InitConfigService = /** @class */ (function () {
    function InitConfigService(httpClient, configService, messageService, neoUtilService) {
        this.httpClient = httpClient;
        this.configService = configService;
        this.messageService = messageService;
        this.neoUtilService = neoUtilService;
        this.initConfigApi = '';
        this.neoCoreConfig = this.configService;
    }
    /**
     * @return {?}
     */
    InitConfigService.prototype.load = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var skipRoutes, pathStr, url, initialRoute, customDomain, host, jwtToken;
            var _this = this;
            return __generator(this, function (_a) {
                skipRoutes = this.neoCoreConfig.skipRoutes;
                pathStr = ((window.location.pathname).split(';')[0]).slice(1);
                if (skipRoutes && skipRoutes.length > 0) {
                    if (skipRoutes.indexOf(pathStr) !== -1) {
                        return [2 /*return*/, false];
                    }
                }
                if (!this.neoUtilService.hasAccessToken()) {
                    url = window.location.href;
                    initialRoute = url.substring(url.indexOf('/', 8));
                    if (initialRoute.indexOf('id_token=') === -1 && initialRoute.indexOf('/login') === -1 && initialRoute !== '/') {
                        sessionStorage.setItem('initialRoute', initialRoute);
                    }
                }
                customDomain = window;
                if (customDomain.location.hostname === 'localhost' || this.neoCoreConfig.isCustomHost) {
                    this.initConfigApi = "" + this.neoCoreConfig.graphql_url;
                }
                else {
                    host = customDomain.location.hostname;
                    host = host.substr(host.indexOf('.'), host.length - host.indexOf('.'));
                    this.initConfigApi = "https://graphql" + host + "/";
                }
                this.graphQlurl = this.initConfigApi;
                this.initConfigApi += "apps/" + this.neoCoreConfig.application_id + "/configurations/" + this.neoCoreConfig.config_fetch_env;
                jwtToken = this.neoUtilService.getAccessToken();
                this.envData = this.messageService.getEnv();
                if (!jwtToken) {
                    return [2 /*return*/, this.getInitialConfig().then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        function (data) {
                            _this.envData = data;
                            _this.messageService.setEnv('environmentData', data);
                            _this.setLoginTypeEnv();
                            return data;
                        })).catch((/**
                         * @param {?} err
                         * @return {?}
                         */
                        function (err) {
                            _this.neoUtilService.clearLocalStorage();
                            return true;
                        }))];
                }
                else if (!this.envData) {
                    this.messageService.getClaimObj().then((/**
                     * @param {?} claimData
                     * @return {?}
                     */
                    function (claimData) {
                        if (claimData) {
                            _this.envData = claimData.configuration;
                            _this.messageService.setEnv('environmentData', _this.envData);
                            _this.setLoginTypeEnv();
                        }
                    })).catch((/**
                     * @param {?} err
                     * @return {?}
                     */
                    function (err) {
                        _this.neoUtilService.clearLocalStorage();
                        return true;
                    }));
                }
                else {
                    this.setLoginTypeEnv();
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * @return {?}
     */
    InitConfigService.prototype.setLoginTypeEnv = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var loginType = this.neoUtilService.loginType();
        if (loginType === LoginType.OKTA) {
            this.neoUtilService.setOktaConfig(this.envData);
        }
        else if (loginType === LoginType.AZURE) {
            this.neoUtilService.setAzureConfig(this.envData);
        }
        else if (loginType === LoginType.COGNITO) {
            this.neoUtilService.setCognitoConfig(this.envData);
        }
    };
    /**
     * @return {?}
     */
    InitConfigService.prototype.getInitialConfig = /**
     * @return {?}
     */
    function () {
        return this.httpClient.get("" + this.initConfigApi).toPromise();
    };
    InitConfigService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    InitConfigService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: NeoConfigModel, decorators: [{ type: Inject, args: [NeoConfigService,] }] },
        { type: MessageService },
        { type: NeoUtilService }
    ]; };
    return InitConfigService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/app-constants.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AppConstants = /** @class */ (function () {
    function AppConstants() {
    }
    AppConstants.HEADERCOMPONENT = {
        changePassword: 'Change Password',
        logout: 'Logout',
        logoutConfirmation: 'Do you want to logout?',
        cancel: 'Cancel',
        appInfo: 'App Info',
        appVersion: ' App Version',
        appSdkVersion: ' App-Sdk Version',
    };
    AppConstants.FOOTERCOMPONENT = {
        poweredBy: 'Powered By',
        neoTxt: 'NEO',
        platformTxt: 'PLATFORM'
    };
    AppConstants.LOGINCOMPONENT = {
        SSO: 'SSO',
        COGNITO: 'COGNITO',
        AZURE: 'AZURE',
        B2C: 'B2C',
        FIREBASE: 'FIREBASE'
    };
    return AppConstants;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/login/neo-appsdk-login.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NeoAppsdkLoginComponent = /** @class */ (function () {
    function NeoAppsdkLoginComponent(router, messageService, neoUtilService, oAuthService) {
        this.router = router;
        this.messageService = messageService;
        this.neoUtilService = neoUtilService;
        this.oAuthService = oAuthService;
        this.inCognitoLogin = false;
        this.b2cLogin = false;
        this.hideScreen = true;
        this.currentYear = new Date();
        this.LoginBtnVisible = true;
        this.LoginText = 'Login';
        this.environment = this.messageService.getEnv('environmentData');
    }
    /**
     * @return {?}
     */
    NeoAppsdkLoginComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        var cloud_provider = this.environment.cloud_provider;
        this.loginType = this.environment.login_type;
        if (this.loginType) {
            /** @type {?} */
            var login_types = this.loginType.split(',');
            this.enableSso = login_types.filter((/**
             * @param {?} data
             * @return {?}
             */
            function (data) { return data.toUpperCase() === AppConstants.LOGINCOMPONENT.SSO; })).length > 0;
            this.enableCognito = login_types.filter((/**
             * @param {?} data
             * @return {?}
             */
            function (data) { return data.toUpperCase() === AppConstants.LOGINCOMPONENT.COGNITO; })).length > 0;
            this.enableAzure = login_types.filter((/**
             * @param {?} data
             * @return {?}
             */
            function (data) { return data.toUpperCase() === AppConstants.LOGINCOMPONENT.AZURE; })).length > 0;
            this.enableB2C = login_types.filter((/**
             * @param {?} data
             * @return {?}
             */
            function (data) { return data.toUpperCase() === AppConstants.LOGINCOMPONENT.B2C; })).length > 0;
            this.enableFirebase = login_types.filter((/**
             * @param {?} data
             * @return {?}
             */
            function (data) { return data.toUpperCase() === AppConstants.LOGINCOMPONENT.FIREBASE; })).length > 0;
        }
        else {
            if (cloud_provider && cloud_provider === 'azure' || cloud_provider === 'gcp') {
                this.inCognitoLogin = false;
                this.enableCognito = false;
                this.enableAzure = this.enableAzure === undefined ? true : this.enableAzure;
            }
            else if (cloud_provider && cloud_provider === 'aws') {
                this.enableAzure = false;
                this.enableCognito = this.enableCognito === undefined ? true : this.enableCognito;
            }
            else {
                this.enableAzure = this.enableAzure === undefined ? false : this.enableAzure;
                this.enableCognito = this.enableCognito === undefined ? true : this.enableCognito;
            }
            this.enableSso = this.enableSso === undefined ? true : this.enableSso;
        }
        // const loginTypeBtn = localStorage.getItem('loginType') === 'B2C' ? true: false;
        /** @type {?} */
        var loginTypeBtn = localStorage.getItem('loginType') === 'B2C' ? true : false;
        this.loginUser = new LoginUser();
        if (this.inCognitoLogin) {
            this.neoUtilService.setCognitoConfig(this.environment);
            Auth.currentSession().then((/**
             * @param {?} res
             * @return {?}
             */
            function (res) {
                _this.router.navigateByUrl('/');
            }));
        }
        else if (loginTypeBtn) {
            if (location.hash) {
                /** @type {?} */
                var tokens = location.hash.substr(1).split('&').map((/**
                 * @param {?} kvp
                 * @return {?}
                 */
                function (kvp) { return kvp.split('='); }));
                tokens.forEach((/**
                 * @param {?} tokens
                 * @return {?}
                 */
                function (tokens) {
                    localStorage.setItem(tokens[0], tokens[1]);
                }));
                this.neoUtilService.b2cLoginReturn('/');
                return;
            }
        }
        else {
            this.neoUtilService.ssoReturn();
        }
    };
    /**
     * @return {?}
     */
    NeoAppsdkLoginComponent.prototype.initRegistration = /**
     * @return {?}
     */
    function () {
        window.open(this.environment.neo_idm_url);
    };
    /**
     * @return {?}
     */
    NeoAppsdkLoginComponent.prototype.launchForgotPassword = /**
     * @return {?}
     */
    function () {
        window.open(this.environment.neo_idm_url + '/forgot-password');
    };
    /**
     * @return {?}
     */
    NeoAppsdkLoginComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        this.LoginText = 'Sign In';
        if (this.loginUser.email !== '' && this.loginUser.password !== '') {
            this.neoUtilService.cognitoSignIn(this.loginUser.email, this.loginUser.password);
        }
    };
    /**
     * @return {?}
     */
    NeoAppsdkLoginComponent.prototype.cognitoLogin = /**
     * @return {?}
     */
    function () {
        this.inCognitoLogin = true;
        this.neoUtilService.clearLocalStorage();
        localStorage.setItem('loginType', LoginType.COGNITO);
        this.enableSso = false;
        this.enableCognito = false;
        this.enableAzure = false;
        this.enableB2C = false;
        this.enableFirebase = false;
    };
    /**
     * @return {?}
     */
    NeoAppsdkLoginComponent.prototype.ssoLogin = /**
     * @return {?}
     */
    function () {
        localStorage.setItem('loginType', LoginType.OKTA);
        this.neoUtilService.ssoLogin();
    };
    /**
     * @return {?}
     */
    NeoAppsdkLoginComponent.prototype.azureLogin = /**
     * @return {?}
     */
    function () {
        localStorage.setItem('loginType', LoginType.AZURE);
        this.neoUtilService.azureLogin();
    };
    /**
     * @return {?}
     */
    NeoAppsdkLoginComponent.prototype.azureB2CLogin = /**
     * @return {?}
     */
    function () {
        localStorage.setItem('loginType', LoginType.B2C);
        this.neoUtilService.azureB2CLogin();
    };
    /**
     * @return {?}
     */
    NeoAppsdkLoginComponent.prototype.firebaseLogin = /**
     * @return {?}
     */
    function () {
        // localStorage.setItem('loginType', LoginType.FIREBASE);
        // this.neoUtilService.loginFirebase();
    };
    NeoAppsdkLoginComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-neo-appsdk-login',
                    template: "<ngx-alerts></ngx-alerts>\n\n<div class=\"form-body\">\n    <div class=\"row\">\n        <div class=\"img-holder\">\n            <ng-content select=\"[loginSidebar]\"></ng-content>\n        </div>\n        <div class=\"form-holder\">\n            <div class=\"form-content\">\n                <div class=\"form-items\">\n                    <div class=\"page-links\">\n                        <a class=\"active\">\n                            <ng-content select=\"[loginHeader]\"></ng-content>\n                        </a>\n                    </div>\n                    <ng-container *ngIf=\"inCognitoLogin\">\n                        <form role=\"form\" name='form' (ngSubmit)=\"f.form.valid && onSubmit()\" #f=\"ngForm\">\n                            <label class='label-txt'>Username</label>\n                            <input class=\"form-control\" autofocus type=\"text\" name=\"email\" [(ngModel)]=\"loginUser.email\"\n                                #email=\"ngModel\" placeholder=\"Email Address\"\n                                [ngClass]=\"{ 'is-invalid': f.submitted && email.invalid }\" required email\n                                autocomplete=\"email\">\n                            <div *ngIf=\"f.submitted && email.invalid\" class=\"invalid-feedback email-valid-check\">\n                                <div *ngIf=\"email?.errors?.required\">Email add required</div>\n                                <div *ngIf=\"email?.errors?.email\">Invalid Email id</div>\n                            </div>\n                            <label class='label-txt'>Password</label>\n                            <input class=\"form-control\" type=\"password\" name=\"password\" [(ngModel)]=\"loginUser.password\"\n                                #password=\"ngModel\" placeholder=\"Password\"\n                                [ngClass]=\"{ 'is-invalid': f.submitted && password.invalid }\" required minlength=\"6\"\n                                autocomplete=\"current-password\">\n                            <div *ngIf=\"f.submitted && password.invalid\" class=\"invalid-feedback\">\n                                <div *ngIf=\"password?.errors?.required\">Password Required</div>\n                                <div *ngIf=\"password?.errors?.minlength\">Minimum length 6</div>\n                            </div>\n                            <div class=\"form-button\">\n                                <button id=\"submit\" *ngIf=\"LoginBtnVisible\" type=\"submit\" class=\"ibtn\">Sign In</button>\n                                <a href=\"javascript:void(0)\" (click)=\"launchForgotPassword()\">Forgot Password</a>\n\n                            </div>\n                        </form>\n                        <div class=\"other-links\">\n                            <span>New user\n                                <a href='javascript:void(0)' (click)='initRegistration()'>Create Account</a>\n                            </span>\n                            <br>\n                            <span>&copy;\n                                <a href='https://www.bcone.com' rel=\"noopener noreferrer\" target='_blank'>Bristlecone,\n                                    Inc.</a> Allright reserved</span>\n                        </div>\n                    </ng-container>\n\n                    <ng-container>\n                        <div class=\"form-button\">\n                            <button (click)=\"ssoLogin()\"  *ngIf=\"enableSso\" class=\"ibtn\">Login with SSO</button>\n                            <button (click)=\"azureLogin()\"  *ngIf=\"enableAzure\" class=\"ibtn\">Login with Azure AD</button>\n                            <button (click)=\"cognitoLogin()\" *ngIf=\"enableCognito\" class=\"ibtn\">Login with Cognito</button>\n                            <button (click)=\"azureB2CLogin()\" *ngIf=\"enableB2C\" class=\"ibtn\">Login with B2C</button>            \n                        </div>\n                    </ng-container>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n",
                    styles: [".email-valid-check{padding-bottom:10px}.form-body{background-color:#064e89;height:100%;position:fixed;width:100%}.label-txt{font-size:12px!important;margin-bottom:4px!important;font-weight:400!important}.register-icon{font-size:13px;vertical-align:top}.form-body>.row{position:relative;margin-left:0;margin-right:0;height:100%}.website-logo{display:none;top:50px;left:50px;right:initial;bottom:initial;position:absolute;z-index:1000}.website-logo img{width:100px}.website-logo a{display:inline-block}.website-logo .logo img{width:100px}.website-logo .logo img.logo-size{opacity:0!important;width:60px}.website-logo-inside{margin-bottom:55px}.website-logo-inside img{width:100px}.website-logo-inside a{display:inline-block}.website-logo-inside .logo img{width:100px}.website-logo-inside .logo img.logo-size{opacity:0!important;width:70px}.preview-body{padding-top:70px;padding-bottom:70px;text-align:center}.preview-body .web-logo{margin-bottom:50px}.preview-body .web-logo img{width:130px}.preview-body .web-title{font-size:30px;font-weight:300;color:#000;line-height:35px;margin-bottom:50px}.preview-body .img-link{display:inline-block;width:100%;margin:20px 0;padding:0 5px}.preview-body .img-link img{width:100%;border-radius:15px;box-shadow:0 0 5px rgba(0,123,255,.38);transition:.5s cubic-bezier(.34,1.61,.7,1)}.preview-body .img-link:focus img,.preview-body .img-link:hover img{transform:scale(1.05);box-shadow:0 11px 19px rgba(0,123,255,.18)}.img-holder{display:inline-block;position:absolute;top:0;left:0;width:550px;min-height:700px;height:100%;overflow:hidden;background-color:#fff;padding:60px;text-align:center;z-index:999}.img-holder .info-holder{position:relative;top:50%;transform:translateY(-50%)}.img-holder .info-holder h3{display:inline-block;color:#064e89;text-align:left;font-size:25px;font-weight:900;margin-bottom:30px;width:100%;max-width:378px;padding-right:30px}.img-holder .info-holder p{display:inline-block;color:#064e89;text-align:left;font-size:17px;font-weight:300;line-height:20px;margin-bottom:10px;width:100%;max-width:378px;padding-right:30px}.img-holder .info-holder img{width:100%;max-width:378px}.img-holder .bg{position:absolute;opacity:.23;background-image:none;left:0;top:0;width:100%;height:100%;background-size:cover;background-position:center;z-index:-1}@media (min-height:700px){.img-holder,.website-logo{position:fixed}}.form-holder{margin-left:550px;width:100%;min-height:700px}.form-holder .form-content{position:relative;text-align:center;display:flex;justify-content:center;align-items:center;padding:60px;min-height:100%}.form-holder .form-content ::-webkit-input-placeholder{color:#526489}.form-holder .form-content :-moz-placeholder{color:#526489}.form-holder .form-content ::-moz-placeholder{color:#526489}.form-holder .form-content :-ms-input-placeholder{color:#526489}.form-control:focus{box-shadow:none}.form-control ::-webkit-input-placeholder{color:#526489}.form-control :-moz-placeholder{color:#526489}.form-control ::-moz-placeholder{color:#526489}.form-control :-ms-input-placeholder{color:#526489}.form-content{position:relative;background-color:#064e89}.form-content .form-group{color:#fff;font-size:15px;font-weight:300}.form-content .form-items{display:inline-block;width:100%;max-width:370px;text-align:left;transition:.4s}.form-content h3{color:#fff;text-align:left;font-size:24px;font-weight:900;margin-bottom:10px}.form-content h3.form-title{margin-bottom:30px}.form-content p{color:#fff;text-align:left;font-size:18px;font-weight:300;line-height:20px;margin-bottom:30px}.form-content p.form-subtitle{font-size:16px;margin-bottom:15px}.form-content label{color:#fff;text-align:left;font-size:15px;font-weight:300;line-height:20px;margin-bottom:10px}.form-content .page-links{margin-bottom:34px}.form-content .page-links a{position:relative;display:inline-block;text-decoration:none;color:#fff;font-weight:300;font-size:15px;margin-right:20px;transition:.3s}.form-content .page-links a:last-child{margin-right:0}.form-content .page-links a.active{font-weight:700}.form-content .dropdown-toggle.btn-default,.form-content input{width:100%;padding:7px 10px;height:36px;line-height:normal;text-align:left;border:0;outline:0;border-radius:6px;background-color:#fff;font-size:15px;font-weight:300;color:#8d8d8d;transition:.3s;margin-bottom:14px}.form-content input[type=password]::-webkit-input-placeholder{padding-top:3px;font-size:15px}.form-content input[type=password]:focus{padding-top:5px;padding-bottom:3px}.form-content input[type=password].form-control.ng-touched{padding-top:5px}.form-content input[type=password]{font-size:16px;padding-top:0;height:36px;padding-bottom:3px}.form-content .dropdown-toggle.btn-default:focus,.form-content .dropdown-toggle.btn-default:hover,.form-content input:focus,.form-content input:hover{border:0;background-color:#ebeff8;color:#8d8d8d}.form-content .custom-options{display:flex}.form-content .form-button{margin-top:30px;margin-bottom:25px}.form-content .form-button .ibtn{border-radius:6px;border:0;padding:6px 28px;background-color:#fff;color:#064e89;font-size:14px;font-weight:700;text-decoration:none;cursor:pointer;margin-right:10px;outline:0;transition:.3s;box-shadow:0 0 0 rgba(0,0,0,.16);margin-bottom:10px}.form-content .form-button .ibtn:focus,.form-content .form-button .ibtn:hover{box-shadow:0 5px 6px rgba(0,0,0,.16)}.form-content .form-button a{font-size:13px;font-weight:700;color:#fff}.form-content .form-button.full-width{margin-top:15px}.form-content .form-button.full-width .ibtn{width:100%}.form-content .btn{border-radius:6px;padding:6px 28px;font-size:14px;font-weight:700;margin-right:10px;border:0}.form-content .btn.btn-light{color:#b0c2d0}.form-content .btn.btn-light:focus,.form-content .btn.btn-light:hover{color:#a0b6c6}.form-content .btn:last-child{margin-right:0}.form-content form{margin-bottom:58px}.form-content .other-links span{font-size:12px;font-weight:300;color:#fff;margin-right:20px}.form-content .other-links a{font-size:12px;font-weight:700;color:#fff;margin-right:10px}.form-content .other-links a:last-child{margin-right:0}.form-content .other-links a i{display:inline-block;width:25px;height:25px;background-color:#000;color:#fff;border-radius:25px;text-align:center;padding-top:5px;font-size:15px;margin:0 5px;transition:.3s}.form-content .other-links a i:focus,.form-content .other-links a i:hover{opacity:.8}.form-content.form-sm .dropdown-toggle.btn-default,.form-content.form-sm input,.form-content.form-sm textarea{padding:6px 16px;margin-bottom:10px;font-size:14px}.form-content.form-sm .btn,.form-content.form-sm .form-button .ibtn{padding:4px 28px}.form-content .form-sent{position:absolute;text-align:center;opacity:0;pointer-events:none;z-index:1;transform-origin:center center;transform:scale(.7) translateX(200px);transition:.4s}.form-content .form-sent.show-it{opacity:1;pointer-events:all;z-index:2;transform:scale(1) translateX(0)}.form-content .form-sent.show-it .tick-holder .tick-icon{-webkit-animation:.7s cubic-bezier(.34,1.61,.7,1) forwards tick-anime3;animation:.7s cubic-bezier(.34,1.61,.7,1) forwards tick-anime3}.form-content .form-sent.show-it .tick-holder .tick-icon:before{-webkit-animation:.2s linear .2s forwards tick-anime1;animation:.2s linear .2s forwards tick-anime1}.form-content .form-sent.show-it .tick-holder .tick-icon:after{-webkit-animation:.4s .4s forwards tick-anime2;animation:.4s .4s forwards tick-anime2}.form-content .form-sent .tick-holder{text-align:center;margin-bottom:12px}.form-content .form-sent .tick-holder .tick-icon{position:relative;display:inline-block;width:40px;height:40px;border-radius:40px;background-color:rgba(255,255,255,0);transform:rotate(35deg) scale(2);transform-origin:center center}.form-content .form-sent .tick-holder .tick-icon:before{content:\"\";position:absolute;background-color:#fff;width:10px;height:2px;top:28px;left:14px;border-radius:2px;transform-origin:left center;transform:scaleX(0)}.form-content .form-sent .tick-holder .tick-icon:after{content:\"\";position:absolute;background-color:#fff;width:2px;height:20px;top:9px;left:22px;border-radius:2px;transform-origin:center bottom;transform:scaleY(0)}.form-content .form-sent h3{text-align:center;color:#fff}.form-content .form-sent p{text-align:center;color:#fff;font-size:15px;opacity:.8;margin-bottom:20px}.form-content .form-sent .info-holder{font-size:12px;font-weight:700;color:#fff;border-top:1px solid rgba(255,255,255,.5);padding:10px;margin-top:60px}.form-content .form-sent .info-holder span{font-size:12px;font-weight:700;color:#fff;opacity:.6}.form-content .form-sent .info-holder a{font-size:12px;font-weight:700;color:#fff;opacity:.9}.form-content .hide-it{opacity:0;z-index:1;pointer-events:none;transform-origin:center center;transform:scale(.7) translateX(-200px)}@-webkit-keyframes tick-anime1{0%{transform:scaleX(0)}100%{transform:scaleX(1)}}@keyframes tick-anime1{0%{transform:scaleX(0)}100%{transform:scaleX(1)}}@-webkit-keyframes tick-anime2{0%{transform:scaleY(0)}100%{transform:scaleY(1)}}@keyframes tick-anime2{0%{transform:scaleY(0)}100%{transform:scaleY(1)}}@-webkit-keyframes tick-anime3{0%{background-color:rgba(255,255,255,0);transform:rotate(35deg) scale(2)}100%{background-color:rgba(255,255,255,.2);transform:rotate(45deg) scale(1)}}@keyframes tick-anime3{0%{background-color:rgba(255,255,255,0);transform:rotate(35deg) scale(2)}100%{background-color:rgba(255,255,255,.2);transform:rotate(45deg) scale(1)}}@-webkit-keyframes c-tick-anime3{0%{background-color:rgba(233,253,214,0);transform:rotate(35deg) scale(2)}100%{background-color:#e9fdd6;transform:rotate(45deg) scale(1)}}@keyframes c-tick-anime3{0%{background-color:rgba(233,253,214,0);transform:rotate(35deg) scale(2)}100%{background-color:#e9fdd6;transform:rotate(45deg) scale(1)}}.form-body.without-side .website-logo{top:70px;left:50%;margin-left:-50px;right:initial;bottom:initial;display:inline-block}.form-body.without-side .form-holder .form-content ::-webkit-input-placeholder{color:#000}.form-body.without-side .form-holder .form-content :-moz-placeholder{color:#000}.form-body.without-side .form-holder .form-content ::-moz-placeholder{color:#000}.form-body.without-side .form-holder .form-content :-ms-input-placeholder{color:#000}.form-body.without-side h3,.form-body.without-side label,.form-body.without-side p{color:#000}.form-body.without-side .img-holder{z-index:0;width:100%;overflow:hidden}.form-body.without-side .img-holder .info-holder img{display:none;max-width:534px;-webkit-animation:50s linear infinite zoom-in-img;animation:50s linear infinite zoom-in-img;transform-origin:center center;transform:scale(1)}.form-body.without-side .form-holder{margin-left:0}.form-body.without-side .form-holder .form-content{background-color:transparent}.form-body.without-side .form-content{padding:125px 60px 60px;-ms-perspective:800px;perspective:800px}.form-body.without-side .form-content .form-items{padding:35px 30px;border-radius:10px;background-color:#fff;box-shadow:0 6px 15px rgba(0,0,0,.16)}.form-body.without-side .form-content .form-items form{margin-bottom:0}.form-body.without-side .form-content .form-items .other-links{margin-top:38px;margin-bottom:30px}.form-body.without-side .form-content .form-items .other-links .text{font-size:13px;font-weight:300;color:#000;margin-bottom:15px}.form-body.without-side .form-content .form-items .other-links a{display:inline-block;padding:5px;border-radius:2px;color:#000;background-color:#f7f7f7}.form-body.without-side .form-content .form-items .other-links a i{width:18px;height:18px;font-size:9px;margin-left:0}.form-body.without-side .form-content .form-items .page-links{margin-bottom:0}.form-body.without-side .form-content .form-items .page-links a{font-weight:700}.form-body.without-side .form-content .form-items .page-links a:after{bottom:-3px}.form-body.without-side .form-content .page-links a{color:#000}.form-body.without-side .form-content .page-links a:after{background-color:rgba(222,222,222,.7)}.form-body.without-side .form-content .page-links a.active:after,.form-body.without-side .form-content .page-links a:focus:after,.form-body.without-side .form-content .page-links a:hover:after{background-color:#0092fe}.form-body.without-side .form-content .dropdown-toggle.btn-default,.form-body.without-side .form-content input{border:0;background-color:#f7f7f7;color:#000}.form-body.without-side .form-content .dropdown-toggle.btn-default:focus,.form-body.without-side .form-content .dropdown-toggle.btn-default:hover,.form-body.without-side .form-content input:focus,.form-body.without-side .form-content input:hover{border:0;background-color:#eaeaea;color:#000}.form-body.without-side .form-content textarea{background-color:#f7f7f7;border:0;color:#000}.form-body.without-side .form-content textarea:focus,.form-body.without-side .form-content textarea:hover{border:0;background-color:#eaeaea;color:#000}.form-body.without-side .form-content .form-button .ibtn{background-color:#29a4ff;color:#fff;box-shadow:0 0 0 rgba(0,0,0,.16)}.form-body.without-side .form-content .form-button .ibtn:focus,.form-body.without-side .form-content .form-button .ibtn:hover{box-shadow:0 5px 6px rgba(0,0,0,.16)}.form-body.without-side .form-content .form-button a{font-weight:300;color:#000}@-webkit-keyframes zoom-in-img{0%,100%{transform:scale(1)}50%{transform:scale(1.15)}}@keyframes zoom-in-img{0%,100%{transform:scale(1)}50%{transform:scale(1.15)}}@media (max-width:992px){.img-holder{display:none}.form-holder{margin-left:0}.form-holder .form-content{padding:125px 60px 60px}.website-logo{top:50px;left:50px;right:initial;bottom:initial}.form-body.without-side .img-holder{display:inline-block}.form-body.without-side .form-holder .form-content{padding:125px 30px 60px}}@media screen and (-ms-high-contrast:active),screen and (-ms-high-contrast:none){.form-holder .form-content{height:100%}}"]
                }] }
    ];
    /** @nocollapse */
    NeoAppsdkLoginComponent.ctorParameters = function () { return [
        { type: Router },
        { type: MessageService },
        { type: NeoUtilService },
        { type: OAuthService }
    ]; };
    NeoAppsdkLoginComponent.propDecorators = {
        enableCognito: [{ type: Input }],
        enableSso: [{ type: Input }],
        enableAzure: [{ type: Input }],
        enableB2C: [{ type: Input }],
        enableFirebase: [{ type: Input }]
    };
    return NeoAppsdkLoginComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/navbar/navbar.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NavbarComponent = /** @class */ (function () {
    function NavbarComponent(neoUtilService, router, messageService) {
        this.neoUtilService = neoUtilService;
        this.router = router;
        this.messageService = messageService;
        this.showNav = true;
        this.menuItems = [];
        this.environment = this.messageService.getEnv('environmentData');
    }
    /**
     * @return {?}
     */
    NavbarComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.menuItems = [{ feature_id: 1, parent_id: 0, icon: 'loading.gif', Menu_Name: 'Loading...' }];
        if (this.neoUtilService.hasAccessToken()) {
            this.getMenu();
        }
    };
    /**
     * @return {?}
     */
    NavbarComponent.prototype.getMenu = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.neoUtilService.fetchMenu(this.environment.graphql_url).subscribe((/**
         * @param {?} menudata
         * @return {?}
         */
        function (menudata) {
            _this.storeMenuData(menudata);
        }));
    };
    /**
     * @return {?}
     */
    NavbarComponent.prototype.showNavbar = /**
     * @return {?}
     */
    function () {
        this.showNav = !this.showNav;
        if (document.getElementById('sidebar').closest('.menu-content').classList) {
            document.getElementById('left-menu').classList.toggle('expanded');
        }
        if (document.getElementById('menu-icon').classList) {
            document.getElementById('menu-icon').classList.toggle('isOpen');
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    NavbarComponent.prototype.storeMenuData = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        var _this = this;
        /** @type {?} */
        var appDocsList = {};
        this.menuItems = [];
        if (data && data.length > 0) {
            /** @type {?} */
            var menuObj_1 = {};
            /** @type {?} */
            var menuItemObj_1 = {};
            data.forEach((/**
             * @param {?} nav
             * @return {?}
             */
            function (nav) {
                if (nav.url_path !== '/') {
                    menuObj_1[nav.url_path] = nav.url_path;
                    appDocsList[nav.url_path.slice(1)] = nav.doc_url;
                }
                if (!menuItemObj_1[nav.parent_id]) {
                    menuItemObj_1[nav.parent_id] = [nav];
                }
                else {
                    menuItemObj_1[nav.parent_id].push(nav);
                }
                if (!nav.parent_id) {
                    _this.menuItems.push(nav);
                }
            }));
            this.menuItems.forEach((/**
             * @param {?} menu
             * @return {?}
             */
            function (menu) {
                menu.children = [];
                if (menuItemObj_1[menu.feature_id]) {
                    menu['children'] = menuItemObj_1[menu.feature_id];
                }
                if (menu.children.length > 0) {
                    menu.children.forEach((/**
                     * @param {?} subMenu
                     * @return {?}
                     */
                    function (subMenu) {
                        if (menuItemObj_1[subMenu.feature_id]) {
                            subMenu.children = menuItemObj_1[subMenu.feature_id];
                        }
                    }));
                }
            }));
            localStorage.setItem('user_menu_items', JSON.stringify(menuObj_1));
            localStorage.setItem('docUrls', JSON.stringify(appDocsList));
        }
    };
    NavbarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-neo-app-navbar',
                    template: "<div class=\"menu-content\">\n  <div id=\"menu-icon\" class=\"menu-icon menu-icon-arrow\" (click)=\"showNavbar()\">\n    <span></span>\n    <svg x=\"0\" y=\"0\" width=\"54px\" height=\"54px\" viewbox=\"0 0 54 54\">\n      <circle cx=\"25\" cy=\"25\" r=\"16\"></circle>\n    </svg>\n  </div>\n\n  <div>\n    <nav id=\"sidebar\" [className]=\"showNav ? 'menu-collapse' : 'menu-expand'\">\n      <ul class=\"custom-navbar\">\n        <li *ngFor=\"let item of menuItems\" [className]=\"'item.children.length > 0' ? 'hasSubMenu': '' \"\n          routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{exact:true}\">\n          <a [routerLink]=\"item.url_path\" title='{{ item.feature_name}}' *ngIf=\"item.url_path !== '/'\">\n            <img src=\"assets/images/{{item.icon}}\" alt=\"\" class=\"menu_image\">\n            <span style=\"padding-left:15px\">{{ item.feature_name }}</span>\n            <i *ngIf=\"!showNav && item.children && item.children.length > 0\" aria-hidden=\"true\"\n              class=\"arrow fa fa-caret-right\"></i>\n          </a>\n          <a href=\"javascript:void(0);\" title='{{ item.feature_name}}' *ngIf=\"item.url_path === '/'\">\n            <img src=\"assets/images/{{item.icon}}\" alt=\"\" class=\"menu_image\">\n            <span style=\"padding-left:15px\">{{ item.feature_name }}</span>\n            <i *ngIf=\"!showNav && item.children && item.children.length > 0\" aria-hidden=\"true\"\n              class=\"arrow fa fa-caret-right\"></i>\n          </a>\n          <ul class=\"level1\" *ngIf=\"item.children && item.children.length > 0\">\n            <li routerLinkActive=\"active\" *ngFor=\"let submenu of item.children\"\n              [className]=\"'submenu.children.length > 0' ? 'hasSubMenu': '' \">\n              <span>\n                <a [routerLink]=\"submenu.url_path\" *ngIf=\"submenu.url_path !== '/'\"\n                  title='{{ submenu.Menu_Name }}'>{{ submenu.feature_name  }} </a>\n                <a href=\"javascript:void(0);\" *ngIf=\"submenu.url_path === '/'\"\n                  title='{{ submenu.Menu_Name }}'>{{ submenu.feature_name  }} </a>\n                <i *ngIf=\"submenu.children && submenu.children.length > 0\" aria-hidden=\"true\"\n                  class=\"fa fa-caret-right\"></i>\n              </span>\n              <ul class=\"level2\" *ngIf=\"submenu.children && submenu.children.length > 0\">\n                <li routerLinkActive=\"active\" *ngFor=\"let nextsubmenu of submenu.children\">\n                  <span>\n                    <a [routerLink]=\"nextsubmenu.url_path\">{{nextsubmenu.feature_name}}</a>\n                  </span>\n                </li>\n              </ul>\n            </li>\n          </ul>\n        </li>\n      </ul>\n    </nav>\n  </div>\n</div>",
                    styles: [".menu-content{position:fixed;top:0;z-index:4}#sidebar.menu-collapse .custom-navbar li a span{display:none}#sidebar.menu-expand .custom-navbar li a span{display:inline-block}.main-content{display:inline-block;position:relative;top:70px;left:70px;transition:.3s;width:calc(100% - 85px);margin-bottom:60px}.menu-content.expanded+.page-content .main-content{left:270px;transition:none;width:calc(100% - 300px)}.menu-expand{padding:0;margin-top:4px}.menu-expand span.menuToggle{margin-top:10px;top:68px;left:12px}#sidebar{min-width:250px;max-width:250px;background:#105cb0;color:#fff;height:100vh;transition:.3s}#sidebar.menu-collapse{min-width:50px;max-width:80px;text-align:center;margin-top:2px}#sidebar.menu-collapse .sidebar-header h3{display:none}#sidebar.menu-collapse .sidebar-header strong{display:block}#sidebar.menu-collapse ul li a{padding:15px 10px;text-align:center;font-size:12px}#sidebar.menu-collapse ul li a i{margin:0 15px 0 0;display:block;font-size:18px}#sidebar .sidebar-header{padding:15px 10px 10px;background:#105cb0}#sidebar .sidebar-header strong{display:none;font-size:12px}#sidebar .sidebar-header i{font-size:20px}#sidebar ul.custom-navbar{padding:0 0 20px;border-bottom:1px solid #105cb0;list-style-type:none}#sidebar ul.custom-navbar li{position:relative;margin:10px 0;display:block}#sidebar ul.custom-navbar li a{padding:12px 10px;font-size:15px;display:block;color:#fff}#sidebar ul.custom-navbar li a:hover{color:#fff;text-decoration:none}#sidebar ul.custom-navbar li a i{margin-right:0;font-size:20px}#sidebar ul.custom-navbar li.hasSubMenu span i{margin-right:15px;position:absolute;top:20%;right:3px}#sidebar ul.custom-navbar li.hasSubMenu>ul{display:none}#sidebar ul.custom-navbar li.hasSubMenu>ul li{margin:0}#sidebar ul.custom-navbar li.hasSubMenu:hover>ul{display:block}#sidebar ul.custom-navbar li.active>a{color:#fff}#sidebar ul.custom-navbar li ul{list-style-type:none;margin:0;padding:0;position:absolute;left:100%}#sidebar ul.custom-navbar li ul.level1,#sidebar ul.custom-navbar li ul.level2{min-width:150px;top:0;background-color:#105cb0}#sidebar ul.custom-navbar ul.level1 li.hasSubMenu span a{padding:15px 20px!important;text-align:left}#sidebar.menu-expand ul.custom-navbar li a i{margin-right:15px}.footer-content{background-color:#fcfcfc;font-size:12px;box-shadow:0 2px 2px 3px rgba(0,0,0,.15)}.page-top-content .breadcrumb{padding:0;background:0 0;font-size:12px}.padding0{padding:0!important}#pagetitle{font-size:25px;margin:0 0 10px;line-height:1.1}@media (max-width:575.98px){.main-content,.menu-content.expanded+.page-content .main-content{left:0;width:100%}#sidebar{min-width:100%;margin-top:0}#sidebar.menu-collapse{min-width:0;max-width:0;top:-52px;position:relative}.menu-content.expanded{width:100%}.menu-content.expanded .menu-icon.menu-icon-arrow.isOpen{bottom:60px;right:auto;left:42%;position:absolute;top:auto}.menu-content.expanded .menu-icon.menu-icon-arrow.isOpen span{top:30px!important;left:11px!important;right:auto;transform:rotate(45deg);background:#fff}.menu-content.expanded .menu-icon.menu-icon-arrow.isOpen span:after,.menu-content.expanded .menu-icon.menu-icon-arrow.isOpen span:before{background:#fff;width:100%;top:10px;left:-11px;transform:rotate(90deg)}.menu-content.expanded .menu-icon.menu-icon-arrow.isOpen svg{stroke:#fff;transition:stroke-dashOffset,fill .5s}.projTitle{margin-left:35px;font-size:15px!important}#sidebar ul.custom-navbar li{display:none;margin:0}#sidebar ul.custom-navbar li a{padding-left:20px}.expanded #sidebar ul.custom-navbar li{display:block;transition:transform}.copyright em{display:block}.text-right.right-content a{font-size:16px;padding-top:0!important;margin-top:0!important;text-overflow:ellipsis;max-width:100px;white-space:nowrap;overflow:hidden}.text-right.right-content{padding-right:0;padding-left:0}}.menu_image{height:35px;width:35px;padding-right:0}.menu-icon{width:54px;height:51px;margin:0;position:relative;border-radius:50%;top:3px!important;cursor:pointer;z-index:999}.menu-icon span{position:absolute;top:27px;left:30px;transform:translateX(-50%) translateY(-50%);display:block;width:22px;height:2px;background-color:#111}.menu-icon span:after,.menu-icon span:before{content:\"\";background-color:#111;width:22px;height:2px;position:absolute;top:0;left:0;transform:translateY(-6px);transition:transform .5s}.menu-icon span:after{transform:translateY(6px)}.menu-icon:hover span:before{transform:translateY(-8px)}.menu-icon:hover span:after{transform:translateY(8px)}.menu-icon-arrow{transition:transform .5s}.menu-icon-arrow span,.menu-icon-arrow span:after,.menu-icon-arrow span:before{transition:.5s,transform .5s,width .5s;transform-origin:100% 50%}.menu-icon-arrow svg{fill:transparent;stroke-width:2px;stroke:#111;stroke-dashArray:165;stroke-dashOffset:165;transition:stroke-dashOffset 1s,fill .5s}.menu-icon-arrow.isOpen{transform:rotate(180deg);top:2px}.menu-icon-arrow.isOpen span:before{transform:translateY(0) rotate(45deg)}.menu-icon-arrow.isOpen span:after{transform:translateY(0) rotate(-45deg)}.menu-icon-arrow.isOpen span:after,.menu-icon-arrow.isOpen span:before{width:50%;right:0;left:auto}.menu-icon-arrow.isOpen svg{stroke-dashOffset:0}.menu-icon-arrow.isOpen:hover svg{fill:rgba(255,255,255,.1)}.menu-icon.menu-icon-arrow.isOpen span{top:25px;left:25px}.dataCatalog{margin-left:-2%;height:32px}.fa-caret-right{float:right}"]
                }] }
    ];
    /** @nocollapse */
    NavbarComponent.ctorParameters = function () { return [
        { type: NeoUtilService },
        { type: Router },
        { type: MessageService }
    ]; };
    return NavbarComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/header/header.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var neoappSdkVersion = require('../../../../package.json').dependencies['@bcone/neo-app-sdk'];
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(modalService, messageService, appEnv, neoUtilService, router) {
        this.modalService = modalService;
        this.messageService = messageService;
        this.appEnv = appEnv;
        this.neoUtilService = neoUtilService;
        this.router = router;
        this.headerConstant = AppConstants.HEADERCOMPONENT;
        this.showAppInfoPopup = false;
        this.loginpopupvisible = false;
        this.isHelp = false;
        this.isShowMenu = false;
        this.appSdkVersion = neoappSdkVersion;
        this.roleName = 'Loading...';
        this.environment = this.messageService.getEnv('environmentData');
        this.projectTitle = this.appEnv.project.name;
        if (this.environment) {
            this.appVersion = this.environment.app_version;
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    HeaderComponent.prototype.clickout = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        if (event.target.classList.contains('toggleUserDropdown')) {
            this.isShowMenu = true;
        }
        else {
            this.isShowMenu = false;
        }
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.setAuthenticatedUserName();
        this.isCognito = this.neoUtilService.isCognito();
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.setAuthenticatedUserName = /**
     * @return {?}
     */
    function () {
        this.roleName = this.neoUtilService.getUserRole();
        this.userName = this.neoUtilService.getUserName();
        this.userEmail = this.neoUtilService.getUserEmail();
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.signOut = /**
     * @return {?}
     */
    function () {
        this.neoUtilService.signOut();
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.showSignoutPopup = /**
     * @return {?}
     */
    function () {
        this.loginpopupvisible = true;
    };
    /**
     * @param {?} appInfoModal
     * @return {?}
     */
    HeaderComponent.prototype.showAppInfo = /**
     * @param {?} appInfoModal
     * @return {?}
     */
    function (appInfoModal) {
        this.modalService.open(appInfoModal, { centered: true });
    };
    /**
     * @param {?} logoutModal
     * @return {?}
     */
    HeaderComponent.prototype.showLogoutModal = /**
     * @param {?} logoutModal
     * @return {?}
     */
    function (logoutModal) {
        this.modalService.open(logoutModal, { centered: true });
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.openChangePassword = /**
     * @return {?}
     */
    function () {
        this.neoUtilService.openChangePassword();
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.toggleMenu = /**
     * @return {?}
     */
    function () {
        this.isShowMenu = !this.isShowMenu;
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.docRedirect = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var url = window.location.pathname;
        if (url.indexOf(';') !== -1) {
            url = url.substring(0, url.indexOf(';'));
        }
        if (!this.appdocurl) {
            this.appdocurl = JSON.parse(localStorage.getItem('docUrls'));
        }
        if (this.appdocurl != null) {
            /** @type {?} */
            var page = url;
            while (page !== '') {
                if (this.appdocurl[page.slice(1)]) {
                    window.open(this.appdocurl[page.slice(1)], url);
                    return;
                }
                if (page.lastIndexOf('/') !== -1 && page.lastIndexOf('/') !== 0) {
                    page = page.substring(0, page.lastIndexOf('/'));
                }
                else {
                    page = '';
                }
            }
        }
        window.open('https://docs.bristleconeneo.com/', 'document');
    };
    /**
     * @return {?}
     */
    HeaderComponent.prototype.sendSupportMail = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var supportMailId = JSON.parse(localStorage.getItem('claimObj')).supportemailid;
        window.location.assign("mailto:" + supportMailId);
    };
    HeaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-neo-app-header',
                    template: "<div class=\"header-content\" #headerContent>\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <div class=\"col-lg-12 col-sm-12\">\n        <div class=\"row\">\n          <div class=\"col-lg-3 col-6 left-content\">\n            <ng-content select=\"[headerLogo]\"></ng-content>\n          </div>\n          <div class=\"col-lg-9 col-6 text-right right-content right-menu-content\">\n            <ng-content select=\"[navigationLink]\"></ng-content>\n            <div class=\"\">\n              <a class=\"py-s\" style='color: #105cb0;font-weight: bold;vertical-align: bottom;'>\n                {{userName}}\n                <br>\n                <span style='font-size:10px;'>{{roleName | uppercase}}</span>\n              </a>\n              <ul class=\"top-menus d-inline-block\">\n                <li class=\"dropdwon\">\n                  <a class=\"dropdown-toggle\" (click)=\"toggleMenu()\">\n                    <img src='assets/images/user.png' class=\"toggleUserDropdown\" #toggleDropdown alt='User'>\n                  </a>\n                  <ul class=\"dropdown-menus\" #dropdownMenu *ngIf=\"isShowMenu\">\n                    <ng-content select=\"[headerMenu]\"></ng-content>\n                    <li>\n                      <a (click)=\"showAppInfo(appInfoModal)\" id=\"appInfo\">\n                        <img src='assets/images/about_icon.png' title='App-Info' class='appinfo-img'\n                          alt='app-Info'>{{ headerConstant?.appInfo}}\n                      </a>\n                    </li>\n                    <li *ngIf=\"isCognito\">\n                      <a (click)=\"openChangePassword()\">\n                        <img src=\"assets/images/profile/password.png\"\n                          alt=\"{{headerConstant?.changePassword}}\">{{ headerConstant?.changePassword}}</a>\n                    </li>\n                    <li>\n                      <a (click)=\"showLogoutModal(logoutModal)\" id=\"logoutlink\">\n                        <img src='assets/images/profile/logout.png' title='Logout' class='logout-img'\n                          alt='Logout'>{{ headerConstant?.logout}}\n                      </a>\n                    </li>\n                  </ul>\n                </li>\n              </ul>\n            </div>\n            <div>\n              <a class=\"customLinks\" (click)=\"sendSupportMail()\"><i style=\"cursor: pointer;\" class=\"fa fa-envelope-o\" aria-hidden=\"true\" title=\"Support Mail\"></i></a>\n            </div>\n            <ng-container *ngIf=\"enableHelp\">\n              <div class=\"d-inline\">\n                <a (click)=\"docRedirect()\" title=\"Help\">\n                  <img src=\"assets/images/help.png\" alt=\"Help\" class=\"bcone-help\" />\n                </a>\n              </div>\n            </ng-container>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n</div>\n<ng-template #appInfoModal let-appInfoModal>\n  <div class=\"modal-header\">\n    <h2 class=\"modal-title\" id=\"modal-basic-title\">\n      <span class=\"modal-title\">{{ headerConstant?.appInfo}}</span>\n    </h2>\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"appInfoModal.close('Cross click')\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n  </div>\n  <div class=\"modal-body\">\n    <p>{{ headerConstant?.appVersion }} - {{appVersion}}</p>\n    <p>{{ headerConstant?.appSdkVersion }} - {{appSdkVersion}}</p>\n  </div>\n</ng-template>\n<ng-template #logoutModal let-logoutModal>\n  <div class=\"modal-header\">\n    <h2 class=\"modal-title\" id=\"modal-basic-title\">\n      <span class=\"modal-title\">{{ headerConstant?.logout}}</span>\n    </h2>\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"logoutModal.close('Cross click')\">\n      <span aria-hidden=\"true\">&times;</span>\n    </button>\n  </div>\n  <div class=\"modal-body\">\n    <h3>{{ headerConstant?.logoutConfirmation }}</h3>\n    <div class=\"button-grp\">\n      <button class=\"btn btn-outline-dark \" type=\"button\"\n        (click)=\"logoutModal.close('Cross click')\">{{ headerConstant?.cancel }}</button>\n      <button class=\"btn btn-primary\" (click)='signOut()'>{{ headerConstant?.logout }}</button>\n    </div>\n  </div>\n</ng-template>",
                    styles: [".py-3{color:#96afcb}.header-content{background-color:#fcfcfc;padding:0;position:fixed;width:100%;display:inline-block;height:60px;z-index:3;box-shadow:0 2px 2px -2px rgba(0,0,0,.15)}.header-content .left-content{padding-left:55px}.header-content .left-content a{padding:10px 0 0;padding-left:52px!important}@media (max-width:575.98px){.header-content .left-content a{padding-left:0!important}}.header-content ul.top-menus{margin:0;padding:0}.header-content ul.top-menus li{display:inline-block;border-left:1px solid #fff;padding:8px 15px;position:relative;width:100%}.header-content ul.top-menus li span .fa{color:#44c4de}.dropdown-toggle,.logout-img{cursor:pointer}.dropdown-toggle:after{display:none}.dropdown-menus{background-color:#fcfcfc;padding:0;border-radius:0;top:56px;right:-12px;border:0;box-shadow:0 3px 5px 0 #a0a0a3;position:absolute;z-index:1000;float:left;min-width:10rem;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-clip:padding-box;width:200px}.dropdown-menus>li{padding:8px 10px}.dropdown-menus>li:hover{background-color:#f2f2f2}.dropdown-menus>li>a{padding:0!important;font-size:14px;cursor:pointer}.dropdown-menus>li img{width:25px;margin-right:8px}.dropdown-menus>li:not(:last-child){border-bottom:1px solid #cecece45}.dropdown-menus:after{bottom:100%;left:158px;border:16px solid rgba(136,183,213,0);content:\" \";height:0;width:0;position:absolute;pointer-events:none;border-bottom-color:#ebebeb;margin-left:-16px}.top-menus .shift-userprofile{display:block;padding:2px;float:right}.bcone-logo{padding:10px 0 10px 33px}.bcone-help{margin:10px 0 10px 10px;padding-left:5px;cursor:pointer}.modal.show .modal-dialog{height:91%;display:flex;align-items:center;justify-content:center}.modal.show .modal-header .close{margin-right:0}.modal.show .close:not(:disabled):not(.disabled){padding-right:10px}.modal-header{display:flex;align-items:flex-start;justify-content:space-between;border-bottom:none;border-top-left-radius:4px;border-top-right-radius:4px;background-color:#105cb0;color:#fff;height:45px;padding:5px 12px}.modal-header .close{float:right;font-size:30px;font-weight:400;line-height:1;color:#fff;text-shadow:0 1px 0 #fff;opacity:1;outline:0}.button-grp{text-align:right}.button-grp .btn{margin:10px}.button-grp .btn:last-child{margin-right:0}.button-grp .btn.btn-primary{background:#105cb0}.customLinks,a.customLinks:not([href]):hover{font-size:25px;vertical-align:middle;margin-top:-4px;color:#1a5191!important}"]
                }] }
    ];
    /** @nocollapse */
    HeaderComponent.ctorParameters = function () { return [
        { type: NgbModal },
        { type: MessageService },
        { type: NeoConfigModel, decorators: [{ type: Inject, args: [NeoConfigService,] }] },
        { type: NeoUtilService },
        { type: Router }
    ]; };
    HeaderComponent.propDecorators = {
        enableHelp: [{ type: Input }],
        clickout: [{ type: HostListener, args: ['document:click', ['$event'],] }]
    };
    return HeaderComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/footer/footer.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FooterComponent = /** @class */ (function () {
    function FooterComponent() {
        this.footerConstant = AppConstants.FOOTERCOMPONENT;
    }
    FooterComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-neo-app-footer',
                    template: "<footer class=\"fixed-bottom\">\n  <div class=\"footer-content\">\n    <div class=\"container-fluid\">\n      <div class=\"row\">\n        <div class=\"col-lg-12 copyright\">\n          <span class=\"customFont\">{{ footerConstant?.poweredBy}}</span>\n          <img src=\"assets/images/footer-logo.png\" alt=\"Footer Logo\">\n          <span class=\"customfooterFont\">{{ footerConstant?.neoTxt }}<sup>&reg;</sup>&nbsp;&nbsp;{{ footerConstant?.platformTxt }}</span>\n        </div>\n      </div>\n    </div>\n  </div>\n</footer>",
                    styles: [".copyright{font-size:12px}.footer-content{background-color:transparent;font-size:1em;box-shadow:none;padding:10px;overflow:hidden;color:#333;text-align:center;font-family:Arial,sans-serif}.footer-content img{max-width:91px;max-height:13px}.footer-content .customFont{font-size:11px}.footer-content .customfooterFont{font-size:12px}.footer-content .customfooterFont sup{font-size:11px}"]
                }] }
    ];
    /** @nocollapse */
    FooterComponent.ctorParameters = function () { return []; };
    return FooterComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/privacy-policy/privacy-policy.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PrivacyPolicyComponent = /** @class */ (function () {
    function PrivacyPolicyComponent(sanitizer, privacyPolicy, neoUtilService, alertService) {
        this.sanitizer = sanitizer;
        this.privacyPolicy = privacyPolicy;
        this.neoUtilService = neoUtilService;
        this.alertService = alertService;
        this.url = 'https://www.bcone.com/privacy-policy/';
        this.showContent = false;
        this.isLoginPage = false;
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
    /**
     * @return {?}
     */
    PrivacyPolicyComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.enablePrivacyPolicy === undefined) {
            this.enablePrivacyPolicy = true;
        }
        this.neoUtilService.isPrivacyPolicyEnabled = this.enablePrivacyPolicy;
        this.subscription = this.privacyPolicy.modalStatus().subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.initialParam = data.initialRoute;
            _this.dynamicRoute = data.dynamicRoute;
            _this.claimData = data.claimData;
            _this.showContent = data.status;
        }));
    };
    /**
     * @return {?}
     */
    PrivacyPolicyComponent.prototype.accept = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var emailId = this.claimData ? this.claimData.userInfo.email : '';
        this.privacyPolicy.updatePrivacyPolicyAcceptance(emailId).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data && data.updateUserByEmail && data.updateUserByEmail.user) {
                _this.privacyPolicy.closeModal();
                _this.showContent = false;
                /** @type {?} */
                var existingInfo = JSON.parse(localStorage.getItem('claimObj'));
                if (existingInfo.userInfo.hasAcceptedPrivacyPolicy !== undefined) {
                    existingInfo.userInfo.hasAcceptedPrivacyPolicy = true;
                }
                existingInfo = JSON.stringify(existingInfo);
                localStorage.setItem('claimObj', existingInfo);
                _this.neoUtilService.getMenuFn(_this.initialParam, _this.dynamicRoute, existingInfo);
            }
            else {
                _this.alertService.danger('Error in accepting privacy policy');
                _this.neoUtilService.signOut();
            }
        }));
    };
    /**
     * @return {?}
     */
    PrivacyPolicyComponent.prototype.cancel = /**
     * @return {?}
     */
    function () {
        this.neoUtilService.signOut();
    };
    /**
     * @return {?}
     */
    PrivacyPolicyComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscription.unsubscribe();
    };
    /**
     * @return {?}
     */
    PrivacyPolicyComponent.prototype.showBconePrivacyPolicy = /**
     * @return {?}
     */
    function () {
        window.open('https://www.bcone.com/privacy-policy/', 'Privacy Policy');
    };
    /**
     * @return {?}
     */
    PrivacyPolicyComponent.prototype.termofuse = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var supportMailId = JSON.parse(localStorage.getItem('claimObj')).supportemailid;
        window.open("https://docs.bristleconeneo.com/termsofuse.html?supportemail=" + supportMailId, 'Privacy Policy');
    };
    PrivacyPolicyComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-neo-app-privacy-policy',
                    template: "<ng-container *ngIf=\"showContent\">\n  <div id=\"myModal\" class=\"neo-modal\">\n    <div class=\"neo-modal-content\">\n      <!-- <iframe width=\"100%\" height=\"100%\" title=\"privacy-policy\" [attr.src]=\"urlSafe\"></iframe> -->\n      <div class=\"neo-button-container\">\n        <p class=\"m-0\">\n          <span class=\"custom text\">Please read the <span (click)=\"termofuse()\">Terms of Use</span> and  <span (click)=\"showBconePrivacyPolicy()\"> Privacy Policy</span>.\n          Please either click Accept to agree to them and to consent to Bristlecone\u2019s receiving and using your personal\n           information to give you access to the Bristlecone NEO\u00AE Platform, or Decline.\n           If you decline, you will not be permitted to use the Bristlecone NEO\u00AE Platform.</span>\n          <button class=\"button button-accept\" (click)=\"accept()\">Accept</button>\n          <button class=\"button button-cancel\" (click)=\"cancel()\">Decline</button>\n        </p>\n      </div>\n    </div>\n  </div>\n</ng-container>\n",
                    styles: [".neo-modal{position:fixed;z-index:1;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:rgba(0,0,0,.25)}.neo-modal-content{background-color:#fefefe;padding:15px 10px;border:1px solid #888;width:100%;position:absolute;bottom:0}.neo-close{color:#aaa;float:right;font-size:28px;font-weight:700}.neo-close:focus,.neo-close:hover{color:#000;text-decoration:none;cursor:pointer}.custom.text{margin-right:15px}.custom.text span{font-weight:700;color:#064e89;cursor:pointer}.neo-button-container{display:inline-block;width:100%;text-align:center}.neo-button-container .button{border-radius:6px;border:0;padding:6px 28px;font-size:14px;font-weight:700;text-decoration:none;cursor:pointer;margin-right:15px;outline:0;transition:.3s;box-shadow:0 0 0 rgba(0,0,0,.16)}.neo-button-container .button.button-cancel{background-color:#fff;color:#064e89;box-sizing:border-box;border:1px solid #ccc}.neo-button-container .button.button-accept{background-color:#064e89;color:#fff}"]
                }] }
    ];
    /** @nocollapse */
    PrivacyPolicyComponent.ctorParameters = function () { return [
        { type: DomSanitizer },
        { type: PrivacyPolicyService },
        { type: NeoUtilService },
        { type: AlertService }
    ]; };
    PrivacyPolicyComponent.propDecorators = {
        enablePrivacyPolicy: [{ type: Input }]
    };
    return PrivacyPolicyComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/graphql.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var GraphQLModule = /** @class */ (function () {
    function GraphQLModule(apollo, httpLink, messageService, configService) {
        this.messageService = messageService;
        this.configService = configService;
        this.envData = this.messageService.getEnv();
        /** @type {?} */
        var customDomain = window;
        /** @type {?} */
        var link = '';
        if (this.envData && this.envData.graphql_url) {
            link = this.envData.graphql_url;
        }
        else if (customDomain.location.hostname === 'localhost') {
            link = this.configService.graphql_url;
        }
        else {
            /** @type {?} */
            var host = customDomain.location.hostname;
            host = host.substr(host.indexOf('.'), host.length - host.indexOf('.'));
            link = "https://graphql" + host + "/";
        }
        apollo.create({
            link: httpLink.create({ uri: link + 'graphql' }),
            cache: new InMemoryCache()
        });
    }
    GraphQLModule.decorators = [
        { type: NgModule, args: [{
                    exports: [
                        HttpClientModule,
                        ApolloModule,
                        HttpLinkModule
                    ]
                },] }
    ];
    /** @nocollapse */
    GraphQLModule.ctorParameters = function () { return [
        { type: Apollo },
        { type: HttpLink },
        { type: MessageService },
        { type: NeoConfigModel, decorators: [{ type: Inject, args: [NeoConfigService,] }] }
    ]; };
    return GraphQLModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/login/neo-appsdk-login.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NeoAppsdkLoginModule = /** @class */ (function () {
    function NeoAppsdkLoginModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    NeoAppsdkLoginModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: NeoAppsdkLoginModule,
            providers: [{
                    provide: NeoConfigService,
                    useValue: config,
                }]
        };
    };
    NeoAppsdkLoginModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        NeoAppsdkLoginComponent,
                        NavbarComponent,
                        HeaderComponent,
                        FooterComponent,
                        PrivacyPolicyComponent
                    ],
                    imports: [
                        BrowserModule,
                        BrowserAnimationsModule,
                        FormsModule,
                        RouterModule,
                        GraphQLModule,
                        NgbModule,
                        OAuthModule.forRoot(),
                        AlertModule.forRoot({ maxMessages: 5, timeout: 5000, position: 'right' }),
                    ],
                    exports: [
                        NeoAppsdkLoginComponent,
                        NavbarComponent,
                        HeaderComponent,
                        FooterComponent,
                        PrivacyPolicyComponent,
                        FormsModule,
                        BrowserModule
                    ],
                    providers: [
                        MessageService,
                        NeoUtilService,
                        PrivacyPolicyService
                    ]
                },] }
    ];
    return NeoAppsdkLoginModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/neo-tableau/neo-tableau.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NeoTableauService = /** @class */ (function () {
    function NeoTableauService(http) {
        this.http = http;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    NeoTableauService.prototype.getTrustedTicket = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        /** @type {?} */
        var requestType = this.splitRequest(data.tableauProxyApi);
        /** @type {?} */
        var queryParam = new HttpParams()
            .set('tenantName', data['tenantName'])
            .set('userName', data['userName']);
        if (requestType === 'get') {
            return this.http.get(data.tableauProxyApi, { params: queryParam })
                .pipe(map((/**
             * @param {?} res
             * @return {?}
             */
            function (res) { return res; })));
        }
        else {
            return this.http.post(data.tableauProxyApi, '', { params: queryParam })
                .pipe(map((/**
             * @param {?} res
             * @return {?}
             */
            function (res) { return res; })));
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    NeoTableauService.prototype.splitRequest = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        if (data && typeof data === 'string') {
            /** @type {?} */
            var envName = data.split('/');
            if (envName.indexOf('neotableau') > -1) {
                return 'get';
            }
            else {
                return 'post';
            }
        }
    };
    NeoTableauService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    NeoTableauService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    return NeoTableauService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/neo-tableau/neo-tableau.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TableauProxyConfigModel = /** @class */ (function () {
    function TableauProxyConfigModel(userName, tenantName, tableauProxyApi) {
        this.userName = userName;
        this.tenantName = tenantName;
        this.tableauProxyApi = tableauProxyApi;
    }
    return TableauProxyConfigModel;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/neo-tableau/neo-tableau.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NeoTableauComponent = /** @class */ (function () {
    function NeoTableauComponent(tableauService, sanitizer) {
        this.tableauService = tableauService;
        this.sanitizer = sanitizer;
        this.isdataLoaded = false;
    }
    /**
     * @return {?}
     */
    NeoTableauComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var self = this;
        /** @type {?} */
        var userData = new TableauProxyConfigModel();
        /** @type {?} */
        var tableauServer;
        /** @type {?} */
        var dashboardpath;
        if (!self.tableauConfig['username'] && !self.tableauConfig['tenantname'] && !self.tableauConfig['tableauProxyApi']
            && !self.tableauConfig['tableauServer'] && !self.tableauConfig['dashboardpath']) {
            console.error('Please configure default tableaConfig details');
        }
        else {
            userData['userName'] = self.tableauConfig.userName;
            userData['tenantName'] = self.tableauConfig.tenantName;
            userData['tableauProxyApi'] = self.tableauConfig.tableauProxyApi;
            tableauServer = self.tableauConfig.tableauServer;
            dashboardpath = self.tableauConfig.dashboardPath;
        }
        this.tableauService.getTrustedTicket(userData).subscribe((/**
         * @param {?} resData
         * @return {?}
         */
        function (resData) {
            _this.isdataLoaded = true;
            /** @type {?} */
            var urlData;
            urlData = "" + tableauServer;
            if (resData === '-1') {
                urlData += "/t/" + userData.tenantName + "/views/" + dashboardpath + "?" +
                    "iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no";
            }
            else {
                urlData += "/trusted/" + resData + "/t/" + userData.tenantName + "/views/" + dashboardpath + "?:embed=yes";
            }
            // this.trustedTicket = urlData;
            _this.trustedTicket = _this.sanitizer.bypassSecurityTrustResourceUrl(urlData);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log(err);
        }));
    };
    NeoTableauComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngx-neo-tableau',
                    template: "<div class=\"tableau-container\" *ngIf=\"isdataLoaded\">\n    <iframe title=\"tableau\" width=\"100%\" [src]=\"trustedTicket\" class=\"tableau-frame\" ></iframe>\n</div>",
                    styles: [".tableau-frame{width:100%;height:calc(100vh - 150px);box-sizing:border-box;border:none}"]
                }] }
    ];
    /** @nocollapse */
    NeoTableauComponent.ctorParameters = function () { return [
        { type: NeoTableauService },
        { type: DomSanitizer }
    ]; };
    NeoTableauComponent.propDecorators = {
        tableauConfig: [{ type: Input }]
    };
    return NeoTableauComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/neo-tableau/neo-tableau.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NeoTableauModule = /** @class */ (function () {
    function NeoTableauModule() {
    }
    NeoTableauModule.decorators = [
        { type: NgModule, args: [{
                    providers: [NeoTableauService],
                    imports: [CommonModule],
                    declarations: [NeoTableauComponent],
                    exports: [NeoTableauComponent, CommonModule]
                },] }
    ];
    return NeoTableauModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/neo-tableau-js/neo-tableau.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NeoTableauService$1 = /** @class */ (function () {
    function NeoTableauService(http) {
        this.http = http;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    NeoTableauService.prototype.getTrustedTicket = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        /** @type {?} */
        var requestType = this.splitRequest(data.tableauProxyApi);
        /** @type {?} */
        var queryParam = new HttpParams()
            .set('tenantName', data['tenantName'])
            .set('userName', data['userName']);
        if (requestType === 'get') {
            return this.http.get(data.tableauProxyApi, { params: queryParam })
                .pipe(map((/**
             * @param {?} res
             * @return {?}
             */
            function (res) { return res; })));
        }
        else {
            return this.http.post(data.tableauProxyApi, '', { params: queryParam })
                .pipe(map((/**
             * @param {?} res
             * @return {?}
             */
            function (res) { return res; })));
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    NeoTableauService.prototype.splitRequest = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        if (data && typeof data === 'string') {
            /** @type {?} */
            var envName = data.split('/');
            if (envName.indexOf('neotableau') > -1) {
                return 'get';
            }
            else {
                return 'post';
            }
        }
    };
    NeoTableauService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    NeoTableauService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    return NeoTableauService;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/neo-tableau-js/neo-tableau.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TableauProxyConfigModel$1 = /** @class */ (function () {
    function TableauProxyConfigModel(userName, tenantName, tableauProxyApi) {
        this.userName = userName;
        this.tenantName = tenantName;
        this.tableauProxyApi = tableauProxyApi;
    }
    return TableauProxyConfigModel;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/neo-tableau-js/neo-tableau.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NeoTableauJSComponent = /** @class */ (function () {
    function NeoTableauJSComponent(tableauService) {
        this.tableauService = tableauService;
        this.isdataLoaded = false;
    }
    /**
     * @return {?}
     */
    NeoTableauJSComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.tableauInstance) {
            console.error('Invalid Tableau api instance');
            return false;
        }
        /** @type {?} */
        var userData = new TableauProxyConfigModel$1();
        /** @type {?} */
        var tableauServer;
        /** @type {?} */
        var dashboardpath;
        if (!this.tableauConfig['username'] && !this.tableauConfig['tenantname'] && !this.tableauConfig['tableauProxyApi']
            && !this.tableauConfig['tableauServer'] && !this.tableauConfig['dashboardpath']) {
            console.error('Please configure default tableaConfig details');
        }
        else {
            userData['userName'] = this.tableauConfig.userName;
            userData['tenantName'] = this.tableauConfig.tenantName;
            userData['tableauProxyApi'] = this.tableauConfig.tableauProxyApi;
            tableauServer = this.tableauConfig.tableauServer;
            dashboardpath = this.tableauConfig.dashboardPath;
        }
        this.tableauService.getTrustedTicket(userData).subscribe((/**
         * @param {?} resData
         * @return {?}
         */
        function (resData) {
            _this.isdataLoaded = true;
            /** @type {?} */
            var urlData;
            urlData = "" + tableauServer;
            if (resData === '-1') {
                urlData += "/t/" + userData.tenantName + "/views/" + dashboardpath + "?" +
                    "iframeSizedToWindow=true&:embed=y&:showAppBanner=false&:display_count=no&:showVizHome=no";
            }
            else {
                urlData += "/trusted/" + resData + "/t/" + userData.tenantName + "/views/" + dashboardpath;
            }
            _this.tableauUrl = urlData;
            _this.initializeViz(_this.tabOption);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            console.log(err);
        }));
    };
    /**
     * @param {?} tabOption
     * @return {?}
     */
    NeoTableauJSComponent.prototype.initializeViz = /**
     * @param {?} tabOption
     * @return {?}
     */
    function (tabOption) {
        /** @type {?} */
        var self = this;
        /** @type {?} */
        var options = tabOption ? tabOption : {};
        options['onFirstInteractive'] = (/**
         * @return {?}
         */
        function () {
            self.workbook = self.viz.getWorkbook();
            self.activeSheet = self.workbook.getActiveSheet();
        });
        this.viz = new this.tableauInstance.Viz(this.gridContainer.nativeElement, this.tableauUrl, options);
    };
    /* RESET FILTER BUTTON CLICK */
    /* RESET FILTER BUTTON CLICK */
    /**
     * @return {?}
     */
    NeoTableauJSComponent.prototype.revertsheet = /* RESET FILTER BUTTON CLICK */
    /**
     * @return {?}
     */
    function () {
        this.workbook.revertAllAsync();
    };
    /* REFRESH DATASOURCE BUTTON CLICK */
    /* REFRESH DATASOURCE BUTTON CLICK */
    /**
     * @return {?}
     */
    NeoTableauJSComponent.prototype.refreshData = /* REFRESH DATASOURCE BUTTON CLICK */
    /**
     * @return {?}
     */
    function () {
        if (this.refreshBtn) {
            return;
        }
        this.viz.refreshDataAsync();
    };
    /* EXPORT DATA BUTTON CLICK */
    /* EXPORT DATA BUTTON CLICK */
    /**
     * @return {?}
     */
    NeoTableauJSComponent.prototype.exportCrossTab = /* EXPORT DATA BUTTON CLICK */
    /**
     * @return {?}
     */
    function () {
        this.viz.showExportCrossTabDialog();
    };
    /* SEE DATA BUTTON CLICK */
    /* SEE DATA BUTTON CLICK */
    /**
     * @return {?}
     */
    NeoTableauJSComponent.prototype.exportData = /* SEE DATA BUTTON CLICK */
    /**
     * @return {?}
     */
    function () {
        this.viz.showExportDataDialog();
    };
    /**
     * @return {?}
     */
    NeoTableauJSComponent.prototype.exportPDF = /**
     * @return {?}
     */
    function () {
        this.viz.showExportPDFDialog();
    };
    NeoTableauJSComponent.decorators = [
        { type: Component, args: [{
                    selector: 'neo-tableau-js',
                    template: "<div class=\"tableau-container\" *ngIf=\"isdataLoaded\">\n    <div class=\"button-container\">\n        <div class=\"button-block\">\n            <button (click)=\"refreshData()\" title=\"Refresh\" class=\"refresh-btn\">\n                <span class=\"refresh-icon\"></span>\n                <span class=\"text text-refresh\">Refresh</span>\n            </button>\n            <button (click)=\"revertsheet()\" title=\"Reset\" class=\"revert-btn\">\n                <span class=\"revert-icon\"></span>\n                <span class=\"text text-revert\">Revert</span>\n            </button>\n            <button (click)=\"exportData()\" title=\"Export\" class=\"export-btn\">\n                <span class=\"export-icon\"></span> \n                <span class=\"text text-export\">Export</span> \n            </button>\n\n            <button (click)=\"exportPDF()\" title=\"Export PDF\" class=\"export-pdf-btn\">\n                <span class=\"export-pdf-icon\"></span> \n                <span class=\"text text-export-pdf\">Export</span> \n            </button>\n        </div>\n    </div>\n</div>\n\n<div #gridContainer></div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    NeoTableauJSComponent.ctorParameters = function () { return [
        { type: NeoTableauService$1 }
    ]; };
    NeoTableauJSComponent.propDecorators = {
        tableauConfig: [{ type: Input }],
        tableauInstance: [{ type: Input }],
        gridContainer: [{ type: ViewChild, args: ['gridContainer',] }],
        tabOption: [{ type: Input }]
    };
    return NeoTableauJSComponent;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: lib/neo-tableau-js/neo-tableau.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NeoTableauJSModule = /** @class */ (function () {
    function NeoTableauJSModule() {
    }
    NeoTableauJSModule.decorators = [
        { type: NgModule, args: [{
                    providers: [NeoTableauService$1],
                    imports: [CommonModule],
                    declarations: [NeoTableauJSComponent],
                    exports: [NeoTableauJSComponent, CommonModule]
                },] }
    ];
    return NeoTableauJSModule;
}());

/**
 * @fileoverview added by tsickle
 * Generated from: projects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: bcone-neo-app-sdk.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AuthGuard, TokenInterceptor, InitConfigService, NeoUtilService, MessageService, NeoAppsdkLoginComponent, NavbarComponent, HeaderComponent, FooterComponent, PrivacyPolicyComponent, PrivacyPolicyService, NeoAppsdkLoginModule, NeoTableauModule, NeoTableauComponent, NeoTableauJSModule, NeoTableauJSComponent, GraphQLModule as ɵc, NeoConfigModel as ɵb, NeoTableauService$1 as ɵe, NeoTableauService as ɵd, NeoConfigService as ɵa };

//# sourceMappingURL=bcone-neo-app-sdk.js.map